/* Team K9 Order Help — /pages/order-help
   Swap a size, start a return, track, report a problem, cancel or change address.
   Talks to the teamk9-order-help Worker. ?demo=1 runs on sample orders (no network),
   ?preview=1 runs real lookups but only previews actions. */
(() => {
  "use strict";

  const root = document.querySelector("[data-tk9oh]");
  if (!root || root.dataset.ready) return;
  root.dataset.ready = "1";

  const params = new URLSearchParams(location.search);
  const cfg = {
    api: root.dataset.api,
    guide: root.dataset.guide || "/pages/harness-guide",
    fitVideo: root.dataset.fitVideo || "https://www.youtube.com/watch?v=EM7vfINEd8Q",
    support: root.dataset.support || "support@teamk9.com",
    demo: params.get("demo") === "1" || root.dataset.demo === "true",
    preview: params.get("preview") === "1",
    customerEmail: root.dataset.customerEmail || "",
    // Embedded in the Support hub: the hub owns the page h1 and the eyebrow.
    embedded: root.dataset.embedded === "true",
    title: root.dataset.title || "Order help",
    subtitle: root.dataset.subtitle || "Swap a size, start a return, or track a package.",
    recent: safeJson(root.querySelector("[data-tk9oh-recent]"))
  };

  // ------------------------------------------------------------------ icons
  const ICONS = {
    swap: '<path d="M7 16V4m0 0L3 8m4-4 4 4"/><path d="M17 8v12m0 0 4-4m-4 4-4-4"/>',
    ret: '<path d="M9 14 4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>',
    truck: '<path d="M3 6h11v10H3z"/><path d="M14 9h4.5L21 12v4h-7"/><circle cx="7" cy="17.5" r="2"/><circle cx="17" cy="17.5" r="2"/>',
    alert: '<path d="M12 9v4m0 3.5h.01"/><path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/>',
    x: '<circle cx="12" cy="12" r="9"/><path d="m15 9-6 6m0-6 6 6"/>',
    pin: '<path d="M12 21s-7-6.2-7-11a7 7 0 1 1 14 0c0 4.8-7 11-7 11z"/><circle cx="12" cy="10" r="2.5"/>',
    back: '<path d="M15 18 9 12l6-6"/>',
    chev: '<path d="m9 18 6-6-6-6"/>',
    check: '<path d="M20 6 9 17l-5-5"/>',
    shield: '<path d="M12 3 4 6v6c0 5 3.4 8.4 8 9 4.6-.6 8-4 8-9V6z"/><path d="m9 12 2 2 4-4"/>',
    box: '<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="m3 8 9 5 9-5M12 13v8"/>',
    camera: '<path d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5"/>',
    ext: '<path d="M14 4h6v6M20 4l-9 9"/><path d="M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5"/>',
    copy: '<rect x="8" y="8" width="12" height="12" rx="2"/><path d="M16 8V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h3"/>',
    ruler: '<path d="M3 17 17 3l4 4L7 21z"/><path d="m7 13 2 2m2-6 2 2m2-6 2 2"/>',
    play: '<circle cx="12" cy="12" r="9"/><path d="m10 9 5 3-5 3z" fill="currentColor"/>',
    info: '<circle cx="12" cy="12" r="9"/><path d="M12 11v5m0-8.5h.01"/>',
    close: '<path d="M18 6 6 18M6 6l12 12"/>',
    plus: '<path d="M12 5v14M5 12h14"/>',
    broken: '<path d="M4 4h16v16H4z"/><path d="m4 14 5-4 3 3 3-2 5 4"/>',
    missing: '<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="M9.5 10.5h5"/>',
    wrong: '<path d="M21 8 12 3 3 8v8l9 5 9-5z"/><path d="m10 10 4 4m0-4-4 4"/>',
    home: '<path d="M3 11 12 4l9 7"/><path d="M5 10v10h14V10"/>',
    expand: '<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>',
    shrink: '<path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7"/>',
    playsolid: '<path d="M8 5v14l11-7z" fill="currentColor" stroke="none"/>',
    chat: '<path d="M4 5h16v11H8l-4 4z"/>',
    paw: '<g fill="currentColor" stroke="none"><circle cx="6.5" cy="9" r="2"/><circle cx="10.5" cy="5.5" r="2"/><circle cx="15" cy="5.5" r="2"/><circle cx="18.5" cy="9.5" r="2"/><path d="M12.5 11.2c-3.2 0-5.8 3.4-5.8 5.6 0 1.7 1.5 2.5 3 2.1 1-.3 1.9-.7 2.8-.7s1.8.4 2.8.7c1.5.4 3-.4 3-2.1 0-2.2-2.6-5.6-5.8-5.6z"/></g>'
  };
  const ic = (name) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${ICONS[name] || ""}</svg>`;

  // ---------------------------------------------------------------- helpers
  function safeJson(node) {
    try { return node ? JSON.parse(node.textContent || "null") || [] : []; } catch { return []; }
  }
  const esc = (value) => String(value == null ? "" : value).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  // Session replays (Merchanting Watch) mask anything inside .rr-mask / [data-watch-mask].
  const pii = (html) => `<span class="rr-mask" data-watch-mask>${html}</span>`;
  const money = (n) => `$${Number(n || 0).toFixed(2)}`;
  const day = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "");
  const num = (name) => String(name || "").replace(/^#/, "");
  const ref = (prefix) => `${prefix}-${Array.from(crypto.getRandomValues(new Uint8Array(6)), (b) => b.toString(16).padStart(2, "0")).join("")}`;
  const img = (src, alt = "") => (src ? `<img src="${esc(src)}" alt="${esc(alt)}" loading="lazy" width="96" height="96">` : "");
  const plural = (n, word) => `${n} ${word}${n === 1 ? "" : "s"}`;
  const WHY = {
    final_sale: "Final sale",
    window: "Past 60 days",
    already_returned: "Return started",
    not_shipped: "Not shipped yet",
    exchange_order: "Exchange order",
    free_item: "Free item",
    one_size: "One size",
    out_of_stock: "Sizes sold out",
    shipped: "Already shipped",
    cancelled: "Cancelled",
    digital: "Digital episode"
  };

  // ------------------------------------------------------------------ fit help
  // Per product line. Videos apply to the Tactical and Classic harnesses only
  // (support agent fitResources.ts); the Lightweight harness has its own guides.
  const CDN = "https://cdn.shopify.com/s/files/1/2715/4364/files/";
  const GUIDES = {
    tactical: `${CDN}New_Harness_Guide_V3__1.23.26_ded5d370-c7b4-47c1-a8df-a35e70c48e50.jpg?v=1774291683`,
    classic: `${CDN}sizeguidesquare_0d900098-3753-4982-bb8f-c24b10a5cb9d.png?v=1`,
    lightweight: `${CDN}lightweight-harness-size-guide-v3_922224b5-5abc-4acd-a1ff-0a7daf9d439b.jpg?v=1789137694`,
    lightweightFit: `${CDN}04-fine-tune-their-fit.png?v=1789089472`
  };
  const video = (id, title, sub) => ({ type: "video", id, title, sub, thumb: `https://i.ytimg.com/vi/${id}/hqdefault.jpg` });
  const guide = (src, title, sub) => ({ type: "guide", src, title, sub, thumb: `${src}&width=500` });
  // Official titles (FAQ page). Tactical + Classic only — never the Lightweight (owner, 2026-09-13).
  const TIGHTEN = video("4dzHaAIMyPA", "How to tighten the straps", "Video · max tightening");
  const ADJUST = video("EM7vfINEd8Q", "Adjust for a perfect fit", "Video · front straps");
  // "Too big" fixes use Garrett's wording (tickets 107704, 108374). Every swap passes the fit check
  // first (owner, 2026-10-04): "too small" gets a loosen-and-measure check before the size picker.
  const harnessTooSmall = (loosen, measure) => ({
    title: "Before you size up, check two things.",
    steps: [
      loosen,
      "Two fingers should fit snugly underneath.",
      `Still tight? Compare your dog's weight and ${measure} with the size guide to help choose a size.`
    ]
  });
  const LOOSEN_ALL = "Let every strap out as far as it goes, then try it on again.";
  const GIVE_BACK = `That's part of our community give-back program. If it's still usable, please consider donating it to a local shelter or rescue. <a class="tk9oh__link" href="/pages/donations" target="_blank" rel="noopener">See how Team K9 gives back</a>`;
  const harnessTooBig = (buckles) => ({
    title: "Most loose fits are a quick strap reset.",
    steps: [
      `Clip ${buckles} and sit the chest strap high — not up near the armpits.`,
      "Pull each strap until the rectangular adjusters slide below the elastic bands. Most harnesses tighten another 4–5 inches per strap.",
      "Two fingers should fit snugly underneath. Tuck the extra strap into the elastic bands — never cut it."
    ]
  });
  const FIT = {
    harness4: {
      chart: [
        { key: "XS", lb: [15, 25], chest: [14, 22], mid: [18, 26] },
        { key: "S", lb: [25, 48], chest: [18, 29], mid: [24, 33] },
        { key: "M", lb: [48, 78], chest: [26, 34], mid: [30, 40] },
        { key: "L", lb: [78, 120], chest: [30, 42], mid: [34, 45] },
        { key: "XL", lb: [120, 170], chest: [29, 44], mid: [37, 48] }
      ],
      measure: { key: "mid", label: "Midsection", hint: "widest part of the belly" },
      betweenSizes: true,
      media: [TIGHTEN, ADJUST, guide(GUIDES.tactical, "Size guide", "Chest + midsection")],
      fixes: { too_big: harnessTooBig("all 4 buckles"), too_small: harnessTooSmall(LOOSEN_ALL, "midsection") },
      floorNote: "XS is our smallest Tactical size. If it's still loose after tightening, we'll help with a return."
    },
    harness2: {
      chart: [
        { key: "S", lb: [20, 45], chest: [16, 27], mid: [24, 33] },
        { key: "M", lb: [45, 75], chest: [24, 31], mid: [30, 39] },
        { key: "L", lb: [75, 115], chest: [27, 41], mid: [34, 45] },
        { key: "XL", lb: [115, 170], chest: [29, 44], mid: [37, 48] }
      ],
      measure: { key: "mid", label: "Belly", hint: "widest part of the belly" },
      betweenSizes: true,
      media: [TIGHTEN, ADJUST, guide(GUIDES.classic, "Size guide", "Chest + belly")],
      fixes: { too_big: harnessTooBig("both buckles"), too_small: harnessTooSmall(LOOSEN_ALL, "belly") },
      floorNote: "Small is the smallest Classic. For a smaller dog, our Tactical harness comes in Extra-Small (15–25 lb) — just reply to your order email."
    },
    harness1: {
      lightweight: true,
      chart: [
        { key: "S", lb: [25, 40], mid: [21.5, 27] },
        { key: "M", lb: [40, 55], mid: [24.5, 30] },
        { key: "L", lb: [55, 80], mid: [27.5, 33] },
        { key: "XL", lb: [80, 100], mid: [29, 35] }
      ],
      measure: { key: "mid", label: "Midsection", hint: "just behind the front legs" },
      media: [guide(GUIDES.lightweightFit, "Fine-tune the fit", "Strap adjustment"), guide(GUIDES.lightweight, "Size guide", "Weight + midsection")],
      fixes: {
        too_big: {
          title: "Snug up the stomach strap.",
          steps: [
            "Slip it over your dog's head and buckle the stomach strap, just behind the front legs.",
            "Tighten the stomach strap until two flat fingers fit snugly under it.",
            "It is the only strap that adjusts. If the chest is still loose after that, compare your dog's weight and midsection with the size guide to see whether to try a smaller size."
          ]
        },
        too_small: harnessTooSmall("Loosen the stomach strap, then try it on again. The chest strap is a fixed length.", "midsection")
      },
      floorNote: "Small is the smallest Lightweight size. If it's still loose after adjusting, we'll help with a return.",
      feedback: "The Lightweight is brand new — fit feedback like yours shapes our next production run. Size swaps are always free."
    },
    collar: {
      chart: [{ key: "M", neck: [13, 17] }, { key: "L", neck: [17, 20] }, { key: "XL", neck: [20, 24] }],
      measure: { key: "neck", label: "Neck", hint: "where the collar sits", only: true },
      media: [],
      fixes: {
        too_big: {
          title: "Check the adjustment first.",
          steps: [
            "Slide the adjuster until two fingers fit snugly under the collar.",
            "Make sure it isn't riding low or rotating around the neck.",
            "Medium (13–17 in) is our smallest — it's the collar XS and Small harness kits come with."
          ]
        },
        too_small: {
          title: "Check the adjustment first.",
          steps: [
            "Slide the adjuster to its longest setting.",
            "Two fingers should fit snugly under the collar.",
            "Still tight? Measure the neck where the collar sits. If a larger size is available, compare your measurement with the sizes on the next step."
          ]
        }
      },
      floorNote: "Medium is our smallest collar. If it's still loose, we'll help with a return."
    }
  };
  const fitFor = (item) => (item ? FIT[item.family] || null : null);
  const ISSUES = [
    ["too_big", "Too big or loose", "Slides, gaps, or backs out", "swap"],
    ["too_small", "Too small or tight", "Hard to buckle or pinches", "swap"]
  ];

  // ------------------------------------------------------------------ state
  const S = {
    view: "find",
    flow: null,
    intent: "",
    data: null,
    token: null,
    via: "email",
    prefill: { order: params.get("order") || "", identity: cfg.customerEmail || "" },
    error: "",
    result: null,
    dir: "fwd"
  };

  // ------------------------------------------------------------------ shell
  root.innerHTML = `
    ${cfg.demo ? `<div class="tk9oh__banner">${ic("info")}Demo mode — sample orders, nothing is sent.</div>` : ""}
    ${cfg.preview && !cfg.demo ? `<div class="tk9oh__banner">${ic("info")}Preview mode — real lookups, actions are only previewed.</div>` : ""}
    <div class="tk9oh__wrap">
      <header class="tk9oh__head">
        ${cfg.embedded ? "" : `<span class="tk9oh__eyebrow">${ic("paw")}Team K9 Support</span>`}
        <${cfg.embedded ? "h2" : "h1"} class="tk9oh__title">${esc(cfg.title)}</${cfg.embedded ? "h2" : "h1"}>
        <p class="tk9oh__sub" data-sub>${esc(cfg.subtitle)}</p>
      </header>
      <section class="tk9oh__card" aria-live="polite">
        <div class="tk9oh__bar" data-bar hidden>
          <div class="tk9oh__bar-side"><button type="button" class="tk9oh__icon-btn" data-act="back">${ic("back")}<span>Back</span></button></div>
          <div class="tk9oh__bar-title" data-bar-title></div>
          <div class="tk9oh__bar-side tk9oh__bar-side--end" data-bar-end></div>
        </div>
        <div class="tk9oh__progress" data-progress hidden><span></span></div>
        <div class="tk9oh__stage" data-stage></div>
      </section>
      <p class="tk9oh__foot" data-foot>Questions? <a href="mailto:${esc(cfg.support)}">${esc(cfg.support)}</a></p>
    </div>`;
  const stage = root.querySelector("[data-stage]");
  const bar = root.querySelector("[data-bar]");
  const barTitle = root.querySelector("[data-bar-title]");
  const barEnd = root.querySelector("[data-bar-end]");
  const progress = root.querySelector("[data-progress]");
  const sub = root.querySelector("[data-sub]");

  // ------------------------------------------------------------------ flows
  const FLOWS = {
    swap: { title: "Swap a size", steps: ["item", "issue", "fix", "size", "confirm"] },
    return: { title: "Start a return", steps: ["items", "reason", "nudge", "confirm"] },
    claim: { title: "Report a problem", steps: ["type", "items", "details"] },
    track: { title: "Track package", steps: ["list"] },
    cancel: { title: "Cancel order", steps: ["confirm"] },
    onway: { title: "Cancel order", steps: ["info"] },
    address: { title: "Change address", steps: ["form"] },
    tracking: { title: "Return tracking", steps: ["form"] },
    episode: { title: "Episode help", steps: ["details"] }
  };

  function go(view, flow = null, dir = "fwd") {
    S.view = view;
    S.flow = flow;
    S.error = "";
    S.dir = dir;
    render();
  }

  function step(name, dir = "fwd") {
    S.flow.step = name;
    S.error = "";
    S.dir = dir;
    render();
  }

  function back() {
    if (S.view === "flow" && S.flow) {
      const steps = activeSteps(S.flow);
      const index = steps.indexOf(S.flow.step);
      if (index > 0) return step(steps[index - 1], "back");
      return go("home", null, "back");
    }
    if (S.view === "done") return refreshHome();
    if (S.view === "home") {
      S.data = null;
      S.token = null;
      return go("find", null, "back");
    }
  }

  /** Skip steps that have only one possible answer. */
  function activeSteps(flow) {
    const steps = FLOWS[flow.kind].steps.slice();
    if (flow.kind === "swap") {
      if (swappable().length <= 1) steps.splice(steps.indexOf("item"), 1);
      // Fit help only after delivery (they've tried it). A swap that started as a return skips it (skipFit).
      const item = flow.itemId ? itemById(flow.itemId) : null;
      if (item && (!fitFor(item) || item.swap.mode !== "exchange" || flow.skipFit)) {
        steps.splice(steps.indexOf("issue"), 1);
        steps.splice(steps.indexOf("fix"), 1);
      } else if (flow.issue && !(fitFor(item).fixes || {})[flow.issue]) {
        steps.splice(steps.indexOf("fix"), 1);
      }
    }
    if (flow.kind === "return" && !nudgeFor(flow)) steps.splice(steps.indexOf("nudge"), 1);
    if (flow.kind === "claim" && flow.type === "not_received" && deliveredPackages().length <= 1) steps.splice(steps.indexOf("items"), 1);
    return steps;
  }

  // ------------------------------------------------------------------ render
  function render() {
    const views = { find: viewFind, home: viewHome, flow: viewFlow, done: viewDone };
    stage.innerHTML = (views[S.view] || viewFind)();
    stage.classList.remove("is-entering", "is-back");
    void stage.offsetWidth;
    stage.classList.add(S.dir === "back" ? "is-back" : "is-entering");

    const inFlow = S.view === "flow" && S.flow;
    bar.hidden = S.view === "find";
    sub.hidden = S.view !== "find";
    barTitle.innerHTML = inFlow ? esc(FLOWS[S.flow.kind].title) : S.data ? `Order ${pii(esc(S.data.order.name))}` : "";
    barEnd.innerHTML = inFlow || S.view === "done"
      ? `<button type="button" class="tk9oh__icon-btn" data-act="home" aria-label="Back to order">${ic("close")}</button>`
      : "";
    if (inFlow) {
      const steps = activeSteps(S.flow);
      const index = Math.max(0, steps.indexOf(S.flow.step));
      progress.hidden = steps.length < 2;
      progress.firstElementChild.style.width = `${((index + 1) / steps.length) * 100}%`;
    } else {
      progress.hidden = true;
    }
    if (S.view === "flow" && S.flow && S.flow.kind === "swap" && S.flow.step === "size") updateFinder();
    if (S.view === "flow" && S.flow && S.flow.kind === "swap" && S.flow.step === "fix") updateSizer(false);
    watchScreen();
    const focusable = stage.querySelector("[data-autofocus]");
    if (focusable && S.dir !== "back" && window.matchMedia("(min-width: 700px)").matches) focusable.focus({ preventScroll: true });
    if (S.view !== "find") {
      const top = root.getBoundingClientRect().top + window.scrollY - 24;
      if (window.scrollY > top + 40) window.scrollTo({ top, behavior: "smooth" });
    }
  }

  const errorBox = () => (S.error ? `<div class="tk9oh__error" role="alert">${ic("alert")}<span>${esc(S.error)}</span></div>` : "");
  const trust = () => `<ul class="tk9oh__trust">
      <li>${ic("swap")}Free harness size swaps</li><li>${ic("shield")}60-day guarantee</li><li>${ic("check")}No restocking fees</li>
    </ul>`;

  // ------------------------------------------------------------------ find
  function viewFind() {
    const recent = !cfg.demo && cfg.recent && cfg.recent.length
      ? `<div class="tk9oh__section-label" style="margin-top:0">Your recent orders</div>
         <div class="tk9oh__recent">${cfg.recent.slice(0, 3).map((order) => `
           <button type="button" class="tk9oh__recent-item" data-act="recent" data-order="${esc(num(order.name))}">
             ${order.image ? img(order.image) : `<span class="tk9oh__thumb"></span>`}
             <span><b>${pii(esc(order.name))}</b><span>${esc(order.date)} · ${plural(order.count, "item")}</span></span>
             <span class="tk9oh__chev">${ic("chev")}</span>
           </button>`).join("")}
         </div>
         <div class="tk9oh__divider">or look up another order</div>`
      : "";
    const demo = cfg.demo
      ? `<div class="tk9oh__section-label" style="margin-top:0">Try a sample order</div>
         <div class="tk9oh__recent">
           <button type="button" class="tk9oh__recent-item" data-act="demo-order" data-order="268431">${img(DEMO_IMG.harness)}<span><b>#268431 · Delivered</b><span>Harness kit, collar, custom patches</span></span><span class="tk9oh__chev">${ic("chev")}</span></button>
           <button type="button" class="tk9oh__recent-item" data-act="demo-order" data-order="268512">${img(DEMO_IMG.lightweight)}<span><b>#268512 · Delivered</b><span>Lightweight harness — its own fit guides</span></span><span class="tk9oh__chev">${ic("chev")}</span></button>
           <button type="button" class="tk9oh__recent-item" data-act="demo-order" data-order="269502">${img(DEMO_IMG.seat)}<span><b>#269502 · Just placed</b><span>Not shipped yet — cancel, edit, change address</span></span><span class="tk9oh__chev">${ic("chev")}</span></button>
           <button type="button" class="tk9oh__recent-item" data-act="demo-order" data-order="271650"><span class="tk9oh__thumb tk9oh__thumb--episode">${ic("playsolid")}</span><span><b>#271650 · Episodes ready</b><span>Chief &amp; Champ welcome + Halloween episodes</span></span><span class="tk9oh__chev">${ic("chev")}</span></button>
         </div>
         <div class="tk9oh__divider">or type it in</div>`
      : "";
    const isZip = S.via === "zip";
    return `
      ${S.intent && INTENT_LABEL[S.intent] ? `<div class="tk9oh__note tk9oh__note--accent" style="margin:0 0 18px">${ic("info")}<span>Look up your order to ${INTENT_LABEL[S.intent]}.</span></div>` : ""}
      ${demo}${recent}
      <form data-form="lookup" novalidate>
        <label class="tk9oh__field">
          <span class="tk9oh__label">Order number</span>
          <input class="tk9oh__input" name="order" inputmode="numeric" autocomplete="off" placeholder="From your confirmation email" value="${esc(S.prefill.order)}" data-autofocus required>
        </label>
        <label class="tk9oh__field">
          <span class="tk9oh__label">${isZip ? "Shipping ZIP code" : "Email"}<small><button type="button" class="tk9oh__link" data-act="toggle-id">${isZip ? "Use email" : "Use ZIP instead"}</button></small></span>
          <input class="tk9oh__input" name="identity" ${isZip ? 'inputmode="numeric" autocomplete="postal-code" placeholder="e.g. 78701"' : 'type="email" autocomplete="email" placeholder="you@email.com"'} value="${esc(isZip ? "" : S.prefill.identity)}" required>
        </label>
        <button class="tk9oh__btn" type="submit">Find my order</button>
        ${errorBox()}
      </form>
      ${trust()}`;
  }

  async function lookup(btn, orderNumber, identity) {
    if (!orderNumber || !identity) {
      S.error = "Enter your order number and the email you used at checkout.";
      return render();
    }
    await busy(btn, async () => {
      const data = await api("lookup", { orderNumber, identity });
      S.token = data.token;
      S.data = data;
      watch("quiz", "complete", "lookup");
      setTimeout(applyIntent, 0);
      S.prefill = { order: orderNumber, identity: S.via === "email" ? identity : S.prefill.identity };
      go("home");
    });
  }

  // ------------------------------------------------------------------ home
  function itemById(id) {
    return S.data.items.find((item) => item.id === id);
  }
  // Chief & Champ episodes (digital, delivered on the dog's episode page) never enter the physical flows.
  const episodes = () => S.data.items.filter((item) => item.episode);
  const physical = () => S.data.items.filter((item) => !item.episode);
  const swappable = () => S.data.items.filter((item) => item.swap && item.swap.ok);
  const returnable = () => S.data.items.filter((item) => item.return && item.return.ok);
  const deliveredPackages = () => S.data.packages.filter((pkg) => pkg.status === "delivered");

  function orderStatus() {
    const { order, packages } = S.data;
    if (order.cancelled) return { key: "cancelled", label: "Cancelled" };
    if (order.refunded) return { key: "cancelled", label: "Refunded" };
    if (order.episodeOnly) {
      const list = episodes();
      return list.every((item) => item.episode.ready) ? { key: "delivered", label: list.length > 1 ? "Episodes ready" : "Episode ready" } : { key: "transit", label: "Being made" };
    }
    const shipped = packages.filter((pkg) => pkg.id !== "unfulfilled");
    if (!shipped.length) return { key: "", label: order.stage === "before_export" ? "Order received" : "Being packed" };
    if (shipped.every((pkg) => pkg.status === "delivered")) return { key: "delivered", label: packages.length > shipped.length ? "Partly delivered" : "Delivered" };
    const attention = shipped.find((pkg) => pkg.status === "attention");
    if (attention) return { key: "attention", label: attention.label };
    return { key: "transit", label: shipped.some((pkg) => pkg.status === "out") ? "Out for delivery" : "On the way" };
  }

  function trackSummary() {
    const shipped = S.data.packages.filter((pkg) => pkg.id !== "unfulfilled");
    if (!shipped.length) return S.data.order.stage === "before_export" ? "Not shipped yet" : "Being packed";
    const delivered = shipped.filter((pkg) => pkg.status === "delivered");
    if (delivered.length === shipped.length) return `Delivered ${day(delivered[delivered.length - 1].deliveredAt)}`;
    return shipped.length > 1 ? `${shipped.length} packages` : shipped[0].label;
  }

  function viewHome() {
    const { order, items, returns } = S.data;
    const status = orderStatus();
    const tiles = [];
    const preShip = order.stage === "before_export";
    if (swappable().length) tiles.push(tile("swap", "swap", "Swap a size", preShip ? "Change it before it ships" : "New size ships free", "", preShip ? "" : "Free"));
    if (returnable().length) tiles.push(tile("return", "ret", "Return for refund", "Within 60 days", "blue"));
    if (S.data.packages.length && !order.cancelled) tiles.push(tile("track", "truck", "Track package", trackSummary(), "gray"));
    if (!order.cancelled && physical().some((item) => item.shipped)) tiles.push(tile("claim", "alert", "Report a problem", "Damaged, missing, wrong", "amber"));
    if (S.data.cancel && S.data.cancel.ok) tiles.push(tile("cancel", "x", "Cancel order", S.data.cancel.mode === "auto" ? "Full refund" : "We'll try to stop it", "gray"));
    // Shipped and not here yet: it cannot be cancelled, but someone who no longer wants it should find the way out.
    else if (S.data.cancel && S.data.cancel.onTheWay && !order.cancelled) tiles.push(tile("onway", "x", "Want to cancel?", "Already shipped. See your options", "gray"));
    if (S.data.address && S.data.address.ok) tiles.push(tile("address", "pin", "Change address", "Before it ships", "gray"));

    const notes = [];
    if (preShip && order.minutesLeft) {
      notes.push(`<div class="tk9oh__note tk9oh__note--accent">${ic("info")}<span><b>Still editable.</b> Your order hasn't gone to our warehouse yet.</span></div>`);
    }
    if (order.cancelled) notes.push(`<div class="tk9oh__note">${ic("info")}<span>This order was cancelled${order.cancelledAt ? ` on ${day(order.cancelledAt)}` : ""}. Any refund goes back to your original payment.</span></div>`);
    else if (order.refunded) notes.push(`<div class="tk9oh__note">${ic("info")}<span>This order has been refunded.</span></div>`);
    if (order.exchangeOrder) notes.push(`<div class="tk9oh__note">${ic("swap")}<span>This is an exchange order. Need another change? We'll handle it personally.</span></div>`);
    if (S.data.teamHelping) notes.push(`<div class="tk9oh__note">${ic("chat")}<span><b>Our team is already helping with this order.</b> Anything you request here goes straight to that conversation, so nothing gets doubled up.</span></div>`);
    if (S.data.verifiedVia === "zip" && !order.episodeOnly) notes.push(`<div class="tk9oh__note">${ic("info")}<span>Looked up with ZIP. For instant swaps and returns, <button type="button" class="tk9oh__link" data-act="restart-email">use your email</button>.</span></div>`);

    const returnCards = returns.map((ret) => {
      const names = ret.items.map((entry) => (itemById(entry.id) || {}).title).filter(Boolean);
      return `<div class="tk9oh__return-card">
        <div class="tk9oh__tile-icon tk9oh__tile-icon--blue">${ic(ret.kind === "exchange" ? "swap" : "ret")}</div>
        <div><b>${ret.kind === "exchange" ? "Swap return" : "Return"} ${pii(esc(ret.name || ""))}</b><span>${esc(names.join(", ") || "In progress")}${ret.tracking ? ` · Return tracking ${pii(esc(ret.tracking.number))}` : ""}</span></div>
        ${ret.tracking ? "" : `<button type="button" class="tk9oh__btn tk9oh__btn--ghost" data-act="add-tracking" data-return="${esc(ret.id)}">Add return tracking</button>`}
      </div>`;
    }).join("");

    return `
      <div class="tk9oh__order-head">
        <div><h2 class="tk9oh__h" tabindex="-1" data-autofocus>${order.firstName ? `Hi ${pii(esc(order.firstName))}` : `Order ${pii(esc(order.name))}`}</h2>
        <div class="tk9oh__meta">Order ${pii(esc(order.name))} · ${esc(day(order.placedAt))}</div></div>
        <span class="tk9oh__pill ${status.key ? `tk9oh__pill--${status.key}` : ""}">${esc(status.label)}</span>
      </div>
      ${order.episodeOnly ? "" : `<div class="tk9oh__thumbs">${items.map((item) => `<div class="tk9oh__thumb${item.episode ? " tk9oh__thumb--episode" : ""}" title="${esc(item.title)}">${item.episode ? ic("playsolid") : img(item.image, item.title)}${item.qty > 1 ? `<i>${item.qty}</i>` : ""}</div>`).join("")}</div>`}
      ${notes.length ? `<div style="margin:-6px 0 22px">${notes.join("")}</div>` : ""}
      ${tiles.length ? `<div class="tk9oh__section-label" style="margin-top:0">What do you need?</div><div class="tk9oh__tiles">${tiles.join("")}</div>` : ""}
      ${episodes().length ? episodeCards(tiles.length > 0) : ""}
      ${returns.length ? `<div class="tk9oh__section-label">In progress</div>${returnCards}` : ""}
      ${!tiles.length && !returns.length && !episodes().length ? `<p class="tk9oh__p">Need a hand with this order? Email <a href="mailto:${esc(cfg.support)}">${esc(cfg.support)}</a>.</p>` : ""}`;
  }

  // Episodes: watch it, or fix it on its page (one free redo or a refund, self-serve), in one tap from here.
  const possessive = (name) => (name ? `${name}${/s$/i.test(name) ? "'" : "'s"}` : "your");
  function episodeCard(item, many) {
    const e = item.episode;
    const state = e.refunded ? "Refunded · still yours to watch" : e.ready ? "Ready to watch" : "Being made · its page shows the progress";
    const watch = many ? `Watch ${esc(item.title)}` : `Watch ${esc(possessive(e.dogName))} episode`;
    return `<div class="tk9oh__episode">
      <div class="tk9oh__episode-head">
        <span class="tk9oh__episode-mark">${ic("playsolid")}</span>
        <div><b>${esc(item.title)}</b><span>${e.dogName ? `Starring ${pii(esc(e.dogName))} · ` : ""}${esc(state)}</span></div>
      </div>
      <a class="tk9oh__btn" href="${esc(e.watchUrl)}" target="_blank" rel="noopener" data-act="episode-open" data-what="watch">${watch}${ic("ext")}</a>
      ${e.ready && !e.refunded ? `<a class="tk9oh__episode-fix" href="${esc(e.fixUrl)}" target="_blank" rel="noopener" data-act="episode-open" data-what="fix"><span><b>Not right?</b> Make it again or get a refund</span>${ic("chev")}</a>` : ""}
    </div>`;
  }
  function episodeCards(belowTiles) {
    const list = episodes();
    return `<div class="tk9oh__section-label"${belowTiles ? "" : ' style="margin-top:0"'}>Your Chief &amp; Champ episode${list.length > 1 ? "s" : ""}</div>
      ${list.map((item) => episodeCard(item, list.length > 1)).join("")}
      ${S.data.verifiedVia === "zip" ? `<p class="tk9oh__episode-note">${ic("info")}<span>The episode page asks for your order email before a redo or a refund.</span></p>` : ""}
      <button type="button" class="tk9oh__episode-help" data-act="start" data-flow="episode">${ic("chat")}<span>Still need help? <b>Message our team</b></span></button>`;
  }

  function hoursLeft(minutes) {
    if (minutes < 60) return `${minutes} min`;
    const hours = Math.floor(minutes / 60);
    return `${hours} hr${hours === 1 ? "" : "s"}`;
  }

  function tile(kind, icon, title, subtitle, tone, pill) {
    return `<button type="button" class="tk9oh__tile" data-act="start" data-flow="${kind}">
      <span class="tk9oh__tile-icon ${tone ? `tk9oh__tile-icon--${tone}` : ""}">${ic(icon)}</span>
      <span class="tk9oh__tile-text"><b>${esc(title)}</b><small>${esc(subtitle)}</small></span>
      ${pill ? `<span class="tk9oh__pill tk9oh__pill--free">${esc(pill)}</span>` : ""}
    </button>`;
  }

  // Hub tiles ("Swap a size") hand the customer's intent to the portal. Without an order
  // it's kept until lookup; the flow only opens if this order offers it (its tile exists).
  const INTENT_LABEL = { swap: "swap a size", return: "start a return", claim: "report a problem", track: "track your package", cancel: "cancel it", address: "change the shipping address" };
  function applyIntent() {
    if (!S.intent || !S.data || S.view !== "home") return;
    const flow = S.intent;
    S.intent = "";
    if (stage.querySelector(`[data-act="start"][data-flow="${flow}"]`)) startFlow(flow);
  }
  // The support chat already looked this order up (live chat on the support engine, 2026-10-07): fill the lookup form
  // so the customer doesn't type it twice. They still press Find my order; nothing is looked up for them.
  document.addEventListener("tk9oh:prefill", (event) => {
    const detail = (event && event.detail) || {};
    const order = String(detail.order || "").replace(/\D/g, "").slice(0, 12);
    if (!order || S.data) return;
    S.via = detail.via === "zip" ? "zip" : "email";
    S.prefill = { order, identity: S.via === "email" ? String(detail.identity || "").slice(0, 200) : S.prefill.identity };
    if (S.view === "find") render();
  });
  document.addEventListener("tk9oh:intent", (event) => {
    const flow = event.detail && event.detail.flow;
    if (!flow || !FLOWS[flow]) return;
    S.intent = flow;
    if (!S.data) return render();
    if (S.view === "flow" && S.flow && S.flow.kind === flow) return;
    go("home");
    applyIntent();
  });

  function startFlow(kind, extra = {}) {
    beacon("flow", { flow: kind });
    lastFlow = kind;
    watch("quiz", "open", `flow.${kind}`);
    const flow = { kind, ...extra };
    if (kind === "swap") {
      const list = swappable();
      flow.itemId = extra.itemId || (list.length === 1 ? list[0].id : null);
      flow.step = flow.itemId ? activeSteps(flow).find((name) => name !== "item") : "item";
      if (flow.itemId && flow.issue && activeSteps(flow).includes("fix")) flow.step = "fix";
      else if (flow.itemId && flow.issue && activeSteps(flow).includes("size")) flow.step = "size";
    } else if (kind === "return") {
      flow.sel = {};
      flow.parts = {};
      returnable().forEach((item) => { if (returnable().length === 1) flow.sel[item.id] = 1; });
      flow.step = "items";
    } else if (kind === "episode") {
      const list = episodes();
      flow.itemId = extra.itemId || (list.length === 1 ? list[0].id : null);
      flow.note = "";
      flow.step = "details";
    } else if (kind === "claim") {
      flow.items = new Set(extra.items || []);
      flow.parts = {};
      flow.photos = [];
      flow.note = "";
      flow.step = extra.type ? (activeSteps({ kind: "claim", type: extra.type }).includes("items") ? "items" : "details") : "type";
      if (extra.type === "not_received" && !flow.packageId) {
        const delivered = deliveredPackages();
        if (delivered.length === 1) flow.packageId = delivered[0].id;
      }
    } else {
      flow.step = FLOWS[kind].steps[0];
    }
    if (kind === "address") flow.addr = { ...(S.data.order.shipTo || {}) };
    go("flow", flow);
  }

  // ------------------------------------------------------------------ flows
  function viewFlow() {
    const f = S.flow;
    const map = {
      "swap:item": swapItem, "swap:issue": swapIssue, "swap:fix": swapFix, "swap:size": swapSize, "swap:confirm": swapConfirm,
      "return:items": returnItems, "return:reason": returnReason, "return:nudge": returnNudge, "return:confirm": returnConfirm,
      "claim:type": claimType, "claim:items": claimItems, "claim:details": claimDetails,
      "episode:details": episodeDetails,
      "track:list": trackList, "cancel:confirm": cancelConfirm, "onway:info": onwayInfo, "address:form": addressForm,
      "tracking:form": () => `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Add return shipment tracking</h2>
        ${trackingForm(S.flow.returnId)}${errorBox()}`
    };
    return (map[`${f.kind}:${f.step}`] || (() => ""))();
  }

  function itemCard(item, opts = {}) {
    const selected = opts.selected ? " is-selected" : "";
    const disabled = opts.disabled ? " is-disabled" : "";
    // A div with a role (not a <button>) so a quantity stepper can live inside it.
    const role = opts.multi ? "checkbox" : "radio";
    const interactive = opts.disabled ? 'aria-disabled="true"' : `tabindex="0" data-act="${opts.act || ""}"`;
    return `<div role="${role}" aria-checked="${opts.selected ? "true" : "false"}" class="tk9oh__item${opts.multi ? " tk9oh__item--multi" : ""}${selected}${disabled}" ${interactive} data-id="${esc(item.id)}">
      <span class="tk9oh__item-img">${img(item.image, item.title)}</span>
      <span class="tk9oh__item-body"><b>${esc(item.title)}</b><span>${esc(opts.detail || item.detail || item.variantLabel)}</span>${includes(item)}${opts.badge ? `<em>${esc(opts.badge)}</em>` : ""}${opts.extra || ""}</span>
      ${opts.disabled ? "" : `<span class="tk9oh__check">${ic("check")}</span>`}
    </div>`;
  }

  /** Kits list what's inside so a kit is never mistaken for one of its parts. */
  function includes(item) {
    if (!item.bundle) return "";
    return `<span class="tk9oh__includes">${item.bundle.components.map((c) => `<i>${esc(c.label)}</i>`).join("")}</span>`;
  }
  const isKitSwap = (item) => Boolean(item.bundle && item.bundle.kind === "kit" && item.swap && item.swap.mode === "exchange");
  const partChips = (item, selected, act) => `<span class="tk9oh__parts" data-stop>${item.bundle.components.map((c) =>
    `<button type="button" class="tk9oh__part${selected && selected.has(c.key) ? " is-selected" : ""}" data-act="${act}" data-id="${esc(item.id)}" data-part="${esc(c.key)}">${esc(c.label)}</button>`).join("")}</span>`;

  // Swap ----------------------------------------------------------------
  function swapItem() {
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Which item?</h2>
      <p class="tk9oh__p">Pick the one that doesn't fit.</p>
      <div class="tk9oh__items">${swappable().map((item) => itemCard(item, { act: "swap-item", selected: S.flow.itemId === item.id })).join("")}</div>`;
  }

  function swapIssue() {
    const item = itemById(S.flow.itemId);
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>What's off with the fit?</h2>
      <p class="tk9oh__p">${esc(item.title)}${item.color ? ` · ${esc(item.color)}` : ""} · ${esc(item.size ? item.size.name : "")}</p>
      <div class="tk9oh__issue-grid">${ISSUES.map(([key, label, sub]) => `
        <button type="button" class="tk9oh__issue" data-act="fit-issue" data-issue="${key}">
          <span class="tk9oh__tile-icon">${ic(key === "too_big" ? "expand" : "shrink")}</span><span>${esc(label)}<small>${esc(sub)}</small></span>
        </button>`).join("")}</div>`;
  }

  function swapFix() {
    const item = itemById(S.flow.itemId);
    const fit = fitFor(item);
    const small = S.flow.issue === "too_small";
    const fix = fit.fixes[S.flow.issue] || fit.fixes.too_big;
    S.flow.fitShown = true;
    beacon("fit_view", { family: item.family, issue: S.flow.issue });
    // "smaller" = a size exists in the direction the customer needs (down for too big, up for too small).
    const smaller = (item.sizes || []).some((size, i, all) => !size.current && size.available && (small ? i > all.findIndex((x) => x.current) : i < all.findIndex((x) => x.current)));
    // The max-tightening video only helps a loose fit.
    const media = fit.media.map((m, i) => ({ m, i })).filter(({ m }) => !(small && m === TIGHTEN));
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Let's make sure it's a size problem</h2>
      <p class="tk9oh__p">${smaller ? "Takes a minute — your free swap is right here if it doesn't help." : "Check the fit below, then continue to see your options."}</p>
      <div class="tk9oh__fix">
        <div class="tk9oh__fix-head"><small>${ic("ruler")}Quick fix · ${esc(item.title)}</small><b>${esc(fix.title)}</b></div>
        <ol class="tk9oh__steps">${fix.steps.map((text) => `<li><span>${esc(text)}</span></li>`).join("")}</ol>
        ${media.length ? `<div class="tk9oh__fix-media">${media.map(({ m, i }) => `
          <button type="button" class="tk9oh__media${m.type === "guide" ? " tk9oh__media--guide" : ""}" data-act="media" data-index="${i}">
            <span class="tk9oh__media-thumb" style="background-image:url('${esc(m.thumb)}')"><i>${ic(m.type === "video" ? "playsolid" : "expand")}</i></span>
            <span class="tk9oh__media-cap">${esc(m.title)}<small>${esc(m.sub)}</small></span>
          </button>`).join("")}</div>` : ""}
      </div>
      ${sizerHtml(item)}
      ${!smaller && !small && fit.floorNote ? `<div class="tk9oh__note">${ic("info")}<span>${esc(fit.floorNote)}</span></div>` : ""}
      ${!smaller && small ? `<div class="tk9oh__note">${ic("info")}<span>No larger size is currently available for this swap. Reply to your order email and we'll help with the options.</span></div>` : ""}
      <div class="tk9oh__fix-actions">
        <button type="button" class="tk9oh__btn tk9oh__btn--good" data-act="fit-fixed">${ic("check")}It fits now, keep this size</button>
        ${smaller
          ? `<button type="button" class="tk9oh__btn" data-act="fit-still">Choose a different size</button>`
          : item.return && item.return.ok
            ? `<button type="button" class="tk9oh__btn" data-act="fit-return">Continue to return</button>`
            : `<a class="tk9oh__btn" href="mailto:${esc(cfg.support)}?subject=${encodeURIComponent(`Order ${S.data.order.name} — fit`)}">Email us about the fit</a>`}
      </div>`;
  }

  /** The size check on the fit screen: a slider over the size chart (dog's weight; neck inches for collars) that shows
   *  which size the chart gives, so the customer sees whether it is really a size problem before picking a new one. */
  function sizerRows(item) {
    const fit = fitFor(item);
    if (!fit) return null;
    const key = fit.measure && fit.measure.only ? fit.measure.key : "lb";
    const rows = fit.chart.filter((row) => row[key]);
    return rows.length > 1 ? { key, rows, unit: key === "lb" ? "lb" : "in" } : null;
  }

  function sizerHtml(item) {
    const spec = sizerRows(item);
    if (!spec) return "";
    const { key, rows, unit } = spec;
    const min = rows[0][key][0], max = rows[rows.length - 1][key][1];
    const current = item.size ? item.size.short : "";
    const had = Number(S.flow[key]);
    const used = Number.isFinite(had) && had >= min && had <= max && Boolean(S.flow.sizerUsed);
    const own = rows.find((row) => row.key === current);
    const start = used ? had : own ? Math.round((own[key][0] + own[key][1]) / 2) : Math.round((min + max) / 2);
    return `<div class="tk9oh__sizer" data-sizer data-key="${key}" data-used="${used}">
      <div class="tk9oh__sizer-head"><b>${key === "lb" ? "Slide to your dog's weight" : "Slide to your dog's neck size"}</b><output data-sizer-val>${used ? `${had} ${unit}` : ""}</output></div>
      <input type="range" min="${min}" max="${max}" step="${key === "lb" ? 1 : 0.5}" value="${start}" data-sizer-range aria-label="${key === "lb" ? "Dog's weight in pounds" : "Neck size in inches"}">
      <div class="tk9oh__zones" aria-hidden="true">${rows.map((row) => `<span data-zone="${esc(row.key)}"${row.key === current ? ' class="is-current"' : ""}><b>${esc(row.key)}</b><small>${row[key][0]}–${row[key][1]} ${unit}</small>${row.key === current ? "<em>Yours</em>" : ""}</span>`).join("")}</div>
      <div class="tk9oh__sizer-out" data-sizer-out aria-live="polite"></div>
    </div>`;
  }

  function updateSizer(fromInput) {
    const box = stage.querySelector("[data-sizer]");
    const item = S.flow && itemById(S.flow.itemId);
    const spec = item && sizerRows(item);
    if (!box || !spec) return;
    const { key, rows, unit } = spec;
    const range = box.querySelector("[data-sizer-range]");
    if (fromInput) {
      S.flow[key] = String(range.value);
      box.dataset.used = "true";
      if (!S.flow.sizerUsed) { S.flow.sizerUsed = true; beacon("fit_sizer", { family: item.family, issue: S.flow.issue }); }
    }
    if (box.dataset.used !== "true") return;
    const value = Number(range.value);
    box.querySelector("[data-sizer-val]").textContent = `${value} ${unit}`;
    // Between two sizes the chart sizes down, so the first row that contains the value wins.
    const row = rows.find((r) => value >= r[key][0] && value <= r[key][1]);
    box.querySelectorAll("[data-zone]").forEach((zone) => zone.classList.toggle("is-on", Boolean(row && row.key === zone.dataset.zone)));
    const out = box.querySelector("[data-sizer-out]");
    const current = item.size ? item.size.short : "";
    const target = row ? (item.sizes || []).find((size) => size.key === row.key) : null;
    if (!row || !target) { out.innerHTML = `<span class="is-warn">Outside our chart. Reply to your order email and we'll help.</span>`; return; }
    if (row.key === current) {
      out.innerHTML = `<span class="is-warn">${esc(target.name)} is the size our chart gives for ${value} ${unit}. ${S.flow.issue === "too_small" ? "Check the straps above before you size up." : "Try the strap adjustment above, then check the fit again."}</span>`;
    } else if (!target.available) {
      out.innerHTML = `<span class="is-warn">Our chart gives ${esc(target.name)} for ${value} ${unit}, and it is sold out right now.</span>`;
    } else {
      out.innerHTML = `<span>Our chart gives ${esc(target.name)} for ${value} ${unit}.</span><button type="button" class="tk9oh__btn tk9oh__btn--small" data-act="sizer-pick" data-size="${esc(target.key)}">Choose ${esc(target.name)}</button>`;
    }
  }

  /** Size finder: weight (and the measurement each line's guide uses). */
  function finderHtml(item) {
    const fit = fitFor(item);
    if (!fit) return "";
    const m = fit.measure;
    const f = S.flow;
    return `<div class="tk9oh__finder" data-finder>
      ${m && m.only ? "" : `<label>Dog's weight <input data-finder-input="lb" inputmode="decimal" placeholder="lb" value="${esc(f.lb || "")}" aria-label="Dog's weight in pounds"></label>`}
      ${m ? `<label>${esc(m.label)} <input data-finder-input="${m.key}" inputmode="decimal" placeholder="in" value="${esc(f[m.key] || "")}" aria-label="${esc(m.label)} in inches, ${esc(m.hint)}"></label>` : ""}
      <output data-finder-out></output>
      ${fit.media.some((x) => x.type === "guide") ? `<button type="button" class="tk9oh__link" data-act="media" data-index="${fit.media.findIndex((x) => x.type === "guide" && /size guide/i.test(x.title))}">Size guide</button>` : ""}
    </div>`;
  }

  function recommend(item) {
    const fit = fitFor(item);
    if (!fit) return null;
    const f = S.flow;
    const sizes = (item.sizes || []).filter((size) => size.available || size.current);
    const inRange = (range, value) => range && value >= range[0] && value <= range[1];
    const measureKey = fit.measure && fit.measure.key;
    const measured = measureKey ? parseFloat(f[measureKey]) : NaN;
    const weight = parseFloat(f.lb);
    let pool = fit.chart.filter((row) => sizes.some((size) => size.key === row.key));
    if (Number.isFinite(measured) && measured > 0) {
      const byMeasure = pool.filter((row) => inRange(row[measureKey], measured));
      if (byMeasure.length) pool = byMeasure;
      else if (!Number.isFinite(weight)) return { key: null, text: "Outside our chart — reply to your order email and we'll help." };
    }
    if (Number.isFinite(weight) && weight > 0) {
      const byWeight = pool.filter((row) => inRange(row.lb, weight));
      if (byWeight.length) pool = byWeight;
      else if (!(Number.isFinite(measured) && measured > 0)) {
        const top = fit.chart[fit.chart.length - 1];
        if (top.lb && weight > top.lb[1]) pool = [top];
        else return { key: null, text: "Outside our chart — reply to your order email and we'll help." };
      }
    }
    if (!(Number.isFinite(weight) && weight > 0) && !(Number.isFinite(measured) && measured > 0)) return null;
    if (!pool.length) return null;
    // Overlapping ranges: between sizes, size down (per the size guide).
    const pick = pool[0];
    const size = item.sizes.find((s) => s.key === pick.key);
    const name = size ? size.name : pick.key;
    if (fit.lightweight) return { key: pick.key, text: `Try ${name}` };
    return { key: pick.key, text: `${name} fits${pool.length > 1 && fit.betweenSizes ? " — between sizes, size down" : ""}` };
  }

  function updateFinder() {
    const item = S.flow && itemById(S.flow.itemId);
    const out = stage.querySelector("[data-finder-out]");
    if (!item || !out) return;
    let reco = recommend(item);
    if (reco && reco.key && item.size && reco.key === item.size.short) {
      reco = { key: null, text: `${item.size.name} is the right size for that — the strap fix usually solves it.`, current: true };
    }
    if (!reco && S.flow.issue && item.sizes) {
      const order = item.sizes.filter((size) => size.available || size.current);
      const at = order.findIndex((size) => size.current);
      const next = S.flow.issue === "too_big" ? order[at - 1] : order[at + 1];
      if (next && !next.current) reco = { key: next.key, text: "", hint: "Likely" };
    }
    S.flow.reco = reco && reco.key;
    out.textContent = reco ? reco.text : "";
    out.classList.toggle("is-warn", Boolean(reco && reco.current));
    stage.querySelectorAll(".tk9oh__size[data-size]").forEach((chip) => {
      const match = reco && reco.key === chip.dataset.size && !chip.disabled;
      chip.classList.toggle("is-suggested", Boolean(match));
      let tag = chip.querySelector("small[data-reco]");
      if (match && !tag) { tag = document.createElement("small"); tag.dataset.reco = "1"; chip.prepend(tag); }
      if (match) tag.textContent = reco.hint || "Best fit";
      if (!match && tag) tag.remove();
    });
  }

  function openMedia(index) {
    const item = itemById(S.flow.itemId);
    const fit = fitFor(item);
    const media = fit && fit.media[Number(index)];
    if (!media) return;
    beacon(media.type === "video" ? "fit_video" : "fit_guide", { family: item.family });
    const box = document.createElement("div");
    box.className = "tk9oh__lightbox";
    box.setAttribute("role", "dialog");
    box.setAttribute("aria-label", media.title);
    box.innerHTML = `<div class="tk9oh__lightbox-inner">
      ${media.type === "video"
        ? `<iframe src="https://www.youtube-nocookie.com/embed/${esc(media.id)}?autoplay=1&rel=0&playsinline=1" title="${esc(media.title)}" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`
        : `<img src="${esc(media.src)}&width=1400" alt="${esc(media.title)}">`}
      <button type="button" class="tk9oh__lightbox-close" aria-label="Close">${ic("close")}</button>
      <div class="tk9oh__lightbox-cap">${esc(media.title)}</div>
    </div>`;
    const close = () => { box.remove(); document.removeEventListener("keydown", onKey); };
    const onKey = (event) => { if (event.key === "Escape") close(); };
    box.addEventListener("click", (event) => { if (event.target === box || event.target.closest(".tk9oh__lightbox-close")) close(); });
    document.addEventListener("keydown", onKey);
    document.body.appendChild(box);
    box.querySelector(".tk9oh__lightbox-close").focus();
  }

  function swapSize() {
    const item = itemById(S.flow.itemId);
    const sizes = item.sizes || [];
    const kit = isKitSwap(item);
    const collar = kit && item.collarSizes && item.collarSizes.length;
    const kept = kit ? item.bundle.components.filter((c) => !c.sizable).map((c) => c.label) : [];
    let kitNote = "";
    if (kit) kitNote = `<div class="tk9oh__note">${ic("box")}<span><b>Kit:</b> pick only the part${collar ? "s" : ""} that don't fit.${kept.length ? ` Your ${esc(kept.join(" and "))} stay${kept.length === 1 ? "s" : ""} with you.` : ""}</span></div>`;
    else if (item.bundle && item.swap.mode === "edit") kitNote = `<div class="tk9oh__note">${ic("box")}<span>Hasn't shipped — the <b>whole ${esc(item.bundle.kind)}</b> switches to the new size.</span></div>`;
    else if (item.bundle) kitNote = `<div class="tk9oh__note">${ic("box")}<span>This is a ${esc(item.bundle.kind)} — our team will swap just the right piece and confirm by email.</span></div>`;
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>${kit ? "What needs a new size?" : "Pick the new size"}</h2>
      <p class="tk9oh__p">${esc(item.title)}${item.color ? ` · ${esc(item.color)}` : ""} · now ${esc(item.size ? item.size.name : "")}</p>
      ${kitNote}
      ${fitFor(item) && fitFor(item).feedback ? `<div class="tk9oh__note tk9oh__note--accent">${ic("chat")}<span>${esc(fitFor(item).feedback)}</span></div>` : ""}
      ${S.flow.issue === "too_small" && !sizes.some((size, i) => size.available && !size.current && i > sizes.findIndex((x) => x.current)) ? `<div class="tk9oh__note">${ic("info")}<span>No larger size is currently available for this swap. Reply to your order email and we'll help with the options.</span></div>` : ""}
      ${finderHtml(item)}
      ${kit ? `<div class="tk9oh__section-label">Harness <span class="tk9oh__muted-inline">· tap again to keep</span></div>` : ""}
      <div class="tk9oh__sizes" role="radiogroup" aria-label="New size">
        ${sizes.map((size) => {
          const cls = size.current ? " is-current" : !size.available ? " is-out" : S.flow.size === size.key ? " is-selected" : "";
          const delta = size.priceDelta ? `<em>${size.priceDelta > 0 ? "+" : "−"}${money(Math.abs(size.priceDelta))}</em>` : "";
          return `<button type="button" role="radio" aria-checked="${S.flow.size === size.key}" class="tk9oh__size${cls}" data-act="swap-size" data-size="${esc(size.key)}" ${size.current || !size.available ? "disabled" : ""}>
            ${size.current ? "<small>Current</small>" : !size.available ? "<small>Sold out</small>" : ""}
            <b>${esc(size.key)}</b><span>${esc(size.range || size.name)}</span>${delta}
          </button>`;
        }).join("")}
      </div>
      ${collar ? `<div class="tk9oh__section-label">Tactical Collar</div>
        <div class="tk9oh__chips">
          <button type="button" class="tk9oh__chip${!S.flow.collarSize ? " is-selected" : ""}" data-act="swap-collar" data-size="">Keep mine</button>
          ${item.collarSizes.filter((c) => c.available).map((c) => `<button type="button" class="tk9oh__chip${S.flow.collarSize === c.key ? " is-selected" : ""}" data-act="swap-collar" data-size="${esc(c.key)}">${esc(c.key)} · ${esc(c.range)}</button>`).join("")}
        </div>` : ""}
      ${fitFor(item) && fitFor(item).media.some((m) => m.type === "video") ? `<div class="tk9oh__help-links">
          ${fitFor(item).media.map((m, i) => (m.type === "video" ? `<button type="button" class="tk9oh__link" data-act="media" data-index="${i}">${ic("play")} ${esc(m.title)}</button>` : "")).join("")}
        </div>` : ""}
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="next" ${S.flow.size || S.flow.collarSize ? "" : "disabled"}>Continue</button></div>`;
  }

  function swapLane(item, target) {
    if (!S.data.live || item.swap.mode === "request") return "request";
    if (item.swap.mode === "edit") return !target || target.priceDelta ? "request" : "edit";
    return "exchange";
  }

  function swapConfirm() {
    const item = itemById(S.flow.itemId);
    const target = S.flow.size ? item.sizes.find((size) => size.key === S.flow.size) : null;
    const collar = S.flow.collarSize ? item.collarSizes.find((c) => c.key === S.flow.collarSize) : null;
    const lane = swapLane(item, target);
    const kit = isKitSwap(item);
    const parts = kit ? [target && "harness", collar && "collar"].filter(Boolean).join(" and ") : "";
    const newThing = kit ? `new ${parts}` : `${target.name}`;
    S.flow.ref = S.flow.ref || ref("swp");
    let steps = "";
    // Same-price swaps are give-back: nothing comes back, and a prepaid label is sent only if the customer asks.
    const giveBack = Boolean(S.data.giveBack) && !(target && target.priceDelta);
    if (lane === "exchange" && giveBack) {
      // The customer picks here what happens to the old one, instead of replying to the confirmation email for a label.
      // The choice is offered only while Order Help says so (2026-10-08, owner: no more send-backs on same-price swaps;
      // the Worker's SWAP_SEND_BACK): without it the old one is always kept or donated.
      const offerBack = Boolean(S.data.sendBackChoice);
      const back = offerBack && Boolean(S.flow.sendBack);
      const old = kit ? `the old ${esc(parts)}` : `the ${esc(item.size.name)}`;
      steps = `<ol class="tk9oh__steps">
        <li><span><b>Your ${esc(newThing)} ship${kit && target && collar ? "" : "s"} free.</b> You'll get a tracking email when it ships.</span></li>
        ${back
          ? `<li><span><b>We email a free return label.</b></span></li>
        <li><span>Send back ${kit ? `just the old ${esc(parts)}` : `the ${esc(item.size.name)}`} with it.</span></li>`
          : `<li><span><b>No need to send ${old} back.</b> ${GIVE_BACK}</span></li>`}
      </ol>${offerBack ? `
      <div class="tk9oh__section-label">What about ${old}?</div>
      <div class="tk9oh__chips" role="radiogroup" aria-label="What happens to the one you have">
        <button type="button" role="radio" aria-checked="${!back}" class="tk9oh__chip${!back ? " is-selected" : ""}" data-act="swap-keep">Keep or donate it</button>
        <button type="button" role="radio" aria-checked="${back}" class="tk9oh__chip${back ? " is-selected" : ""}" data-act="swap-back">I'd rather send it back</button>
      </div>` : ""}`;
    } else if (lane === "exchange") {
      steps = `<ol class="tk9oh__steps">
        <li><span><b>Your ${esc(newThing)} ship${kit && target && collar ? "" : "s"} free.</b> You'll get a tracking email when it ships.</span></li>
        <li><span><b>We email a free return label.</b></span></li>
        <li><span>Send back ${kit ? `just the old ${esc(parts)}` : `the ${esc(item.size.name)}`} with it.</span></li>
      </ol>`;
    } else if (lane === "edit") {
      steps = `<div class="tk9oh__note tk9oh__note--accent">${ic("check")}<span><b>Hasn't shipped yet.</b> Confirm to change the size on your order.</span></div>`;
    } else {
      steps = `<div class="tk9oh__note">${ic("chat")}<span>Our team will confirm by email.</span></div>`;
    }
    const pd = target ? target.priceDelta : 0;
    const delta = pd > 0
      ? `<div class="tk9oh__summary"><div><span>Price difference</span><b>+${money(pd)}</b></div><div><span>How</span><b>Secure invoice by email</b></div></div>`
      : pd < 0
        ? `<div class="tk9oh__summary"><div><span>Price difference</span><b>${money(Math.abs(pd))} back to you</b></div><div><span>When</span><b>Once your original arrives</b></div></div>`
        : "";
    const pic = kit && item.componentImage ? item.componentImage : item.image;
    const visual = target
      ? `<div class="tk9oh__swap">
        <div class="tk9oh__swap-side is-old"><div class="tk9oh__item-img">${img(pic)}</div><b>${esc(item.size.short)}</b><span>${esc(item.size.range || item.size.name)}</span></div>
        <div class="tk9oh__swap-arrow">${ic("chev")}</div>
        <div class="tk9oh__swap-side"><div class="tk9oh__item-img">${img(pic)}</div><b>${esc(target.key)}</b><span>${esc(target.range || target.name)}</span></div>
      </div>`
      : `<div class="tk9oh__swap"><div class="tk9oh__swap-side is-old"><b>Collar</b><span>Current</span></div><div class="tk9oh__swap-arrow">${ic("chev")}</div><div class="tk9oh__swap-side"><b>${esc(collar.key)}</b><span>${esc(collar.range)}</span></div></div>`;
    const keptParts = kit ? item.bundle.components.filter((c) => !(c.key === "harness" && target) && !(c.key === "collar" && collar)).map((c) => c.label) : [];
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Confirm your swap</h2>
      <p class="tk9oh__p">${esc(item.title)}${item.color ? ` · ${esc(item.color)}` : ""}${kit ? ` · ${esc(parts)} only` : ""}</p>
      ${visual}
      ${collar && target ? `<div class="tk9oh__note">${ic("swap")}<span>Collar swaps to <b>${esc(collar.name)}</b> too.</span></div>` : ""}
      ${kit && keptParts.length ? `<div class="tk9oh__note">${ic("box")}<span>Keep your ${esc(keptParts.join(" and "))} — only the ${esc(parts)} ${target && collar ? "are" : "is"} swapped.</span></div>` : ""}
      ${item.bundle && item.swap.mode === "edit" && lane === "edit" ? `<div class="tk9oh__note">${ic("box")}<span>The whole ${esc(item.bundle.kind)} switches to ${esc(target.name)}.</span></div>` : ""}
      ${delta}
      ${steps}
      ${fitFor(item) && fitFor(item).lightweight ? feedbackPhotos() : ""}
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="submit-swap">${lane === "request" ? "Send request" : "Confirm swap"}</button></div>
      ${errorBox()}`;
  }

  function feedbackPhotos() {
    const photos = S.flow.photos || (S.flow.photos = []);
    const slots = photos.map((src, i) => `<div class="tk9oh__photo is-filled rr-block" data-watch-block><img src="${src}" alt="Fit photo ${i + 1}"><button type="button" data-act="photo-remove" data-index="${i}" aria-label="Remove photo">${ic("close")}</button></div>`);
    if (photos.length < 2) slots.push(`<label class="tk9oh__photo">${ic("camera")}<span class="tk9oh__sr">Add a fit photo</span><input type="file" accept="image/*" data-photo></label>`);
    return `<div class="tk9oh__section-label">Help us improve <span class="tk9oh__muted-inline">· optional</span></div>
      <p class="tk9oh__p" style="margin-bottom:10px">A photo of the harness on your dog helps us get the next size run right.</p>
      <div class="tk9oh__photos">${slots.join("")}</div>`;
  }

  async function submitSwap(btn) {
    const item = itemById(S.flow.itemId);
    await busy(btn, async () => {
      const result = await api("exchange", {
        lineItemId: item.id,
        size: S.flow.size || undefined,
        collarSize: S.flow.collarSize || undefined,
        reason: S.flow.issue || undefined,
        fitHelpViewed: Boolean(S.flow.fitShown && !S.flow.skipFit),
        sendBack: S.flow.sendBack && S.data.sendBackChoice ? true : undefined,
        origin: S.flow.fromReturn ? "return_nudge" : undefined,
        measurements: { lb: S.flow.lb || undefined, mid: S.flow.mid || undefined, neck: S.flow.neck || undefined },
        photos: S.flow.photos && S.flow.photos.length ? S.flow.photos : undefined,
        ref: S.flow.ref
      });
      S.result = { ...result, lineItem: item };
      go("done");
    });
  }

  // Return --------------------------------------------------------------
  function returnItems() {
    const list = S.data.items;
    const count = Object.values(S.flow.sel).reduce((a, b) => a + b, 0);
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>What's going back?</h2>
      <p class="tk9oh__p">Refunds go to your original payment once it arrives.</p>
      <div class="tk9oh__items">${list.map((item) => {
        const ok = item.return && item.return.ok;
        const qty = S.flow.sel[item.id] || 0;
        const stepper = ok && qty && item.return.maxQty > 1
          ? `<span class="tk9oh__qty" data-stop><button type="button" data-act="qty" data-id="${esc(item.id)}" data-d="-1" aria-label="Fewer">−</button><output>${qty}</output><button type="button" data-act="qty" data-id="${esc(item.id)}" data-d="1" aria-label="More">+</button></span>`
          : "";
        const parts = S.flow.parts[item.id];
        const kitScope = ok && qty && item.bundle
          ? `<span class="tk9oh__seg" data-stop>
              <button type="button" class="${parts ? "" : "is-on"}" data-act="kit-whole" data-id="${esc(item.id)}">Whole ${esc(item.bundle.kind)}</button>
              <button type="button" class="${parts ? "is-on" : ""}" data-act="kit-some" data-id="${esc(item.id)}">Just some parts</button>
            </span>${parts ? partChips(item, parts, "return-part") : ""}`
          : "";
        return itemCard(item, {
          act: "return-item",
          multi: true,
          selected: Boolean(qty),
          disabled: !ok,
          badge: ok ? "" : WHY[item.return && item.return.why] || "Not returnable",
          detail: `${item.detail || item.variantLabel}${ok ? ` · ${money(item.unitPaid)}` : ""}`,
          extra: stepper + kitScope
        });
      }).join("")}</div>
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="next" ${count && partsValid() ? "" : "disabled"}>Continue</button></div>`;
  }

  /** "Just some parts" needs at least one part, and not every part. */
  function partsValid() {
    return Object.entries(S.flow.parts || {}).every(([id, parts]) => !S.flow.sel[id] || !parts || (parts.size > 0 && parts.size < itemById(id).bundle.components.length));
  }
  const partialReturn = () => Object.entries(S.flow.parts || {}).some(([id, parts]) => S.flow.sel[id] && parts && parts.size);

  /** A swap is offered instead of a fit return only when it's a clean, free swap:
   * one item, delivered, fit reason, and a size exists in the right direction. */
  function nudgeFor(flow) {
    if (!flow || (flow.reason !== "too_small" && flow.reason !== "too_big")) return null;
    const ids = Object.keys(flow.sel || {});
    if (ids.length !== 1) return null;
    if (flow.parts && flow.parts[ids[0]]) return null;
    const item = itemById(ids[0]);
    if (!item || !item.swap || !item.swap.ok || item.swap.mode !== "exchange" || !item.sizes) return null;
    const order = item.sizes.filter((size) => size.available || size.current);
    const at = order.findIndex((size) => size.current);
    const target = flow.reason === "too_big" ? order[at - 1] : order[at + 1];
    if (!target || target.current || target.priceDelta > 0) return null;
    return { item, target };
  }

  function returnNudge() {
    const { item, target } = nudgeFor(S.flow);
    const fit = fitFor(item);
    if (!S.flow.nudgeLogged) { S.flow.nudgeLogged = true; beacon("nudge_shown", { family: item.family, issue: S.flow.reason }); }
    const kit = isKitSwap(item);
    const kept = kit ? item.bundle.components.filter((c) => c.key !== "harness").map((c) => c.label) : [];
    const pic = kit && item.componentImage ? item.componentImage : item.image;
    return `<p class="tk9oh__kicker">Before you send it back</p>
      <h2 class="tk9oh__h" tabindex="-1" data-autofocus>The right size is on us</h2>
      <p class="tk9oh__p">${kit ? "Swap just the harness" : "Swapping"} is free. A return works too — it's your call.</p>
      <div class="tk9oh__choice">
        <div class="tk9oh__choice-card is-pick">
          <span class="tk9oh__pill tk9oh__pill--free">Free</span>
          <div class="tk9oh__choice-visual">
            <span class="tk9oh__item-img">${img(pic, item.title)}</span>
            <span class="tk9oh__choice-sizes"><s>${esc(item.size.short)}</s>${ic("chev")}<b>${esc(target.key)}</b></span>
          </div>
          <b class="tk9oh__choice-title">Swap to ${esc(target.name)}</b>
          <ul class="tk9oh__ticks">
            <li>${ic("check")}Ships now, at no cost to you</li>
            <li>${ic("check")}${S.data.giveBack && !target.priceDelta ? `No need to send the ${esc(item.size.name)} back` : `Free return label for the ${esc(item.size.name)}`}</li>
            <li>${ic("check")}No waiting on a refund</li>
            ${kit && kept.length ? `<li>${ic("check")}Keep your ${esc(kept.join(" and "))}</li>` : ""}
          </ul>
          <button type="button" class="tk9oh__btn" data-act="nudge-swap">Swap to ${esc(target.name)}</button>
        </div>
        <div class="tk9oh__choice-card">
          <b class="tk9oh__choice-title">Return for a refund</b>
          <ul class="tk9oh__ticks is-plain">
            <li>Return shipping is on you</li>
            <li>Refund after it arrives and is checked</li>
          </ul>
          <button type="button" class="tk9oh__btn tk9oh__btn--ghost" data-act="nudge-return">Continue return</button>
        </div>
      </div>
      ${fit && fit.fixes[S.flow.reason] ? `<button type="button" class="tk9oh__link tk9oh__skip" data-act="nudge-fit">Not sure it's the size? Try the ${S.flow.reason === "too_small" || fit.lightweight || !fit.media.some((m) => m.type === "video") ? "quick fit check" : "60-second strap fix"}</button>` : ""}`;
  }

  const REASONS = [
    ["too_small", "Too small"], ["too_big", "Too big"], ["changed_mind", "Changed my mind"], ["not_expected", "Not what I expected"], ["other", "Other"]
  ];

  function returnReason() {
    const fit = S.flow.reason === "too_small" || S.flow.reason === "too_big";
    const swapCandidate = fit && !nudgeFor(S.flow) && Object.keys(S.flow.sel).map(itemById).find((item) => item && item.swap && item.swap.ok && item.swap.mode === "exchange");
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>What's the reason?</h2>
      <p class="tk9oh__p">Helps us make our gear better.</p>
      <div class="tk9oh__chips">${REASONS.map(([key, label]) => `<button type="button" class="tk9oh__chip${S.flow.reason === key ? " is-selected" : ""}" data-act="reason" data-reason="${key}">${label}</button>`).join("")}</div>
      ${swapCandidate ? `<div class="tk9oh__note tk9oh__note--accent">${ic("swap")}<span><b>A new size ships free — returns don't.</b> <button type="button" class="tk9oh__link" data-act="swap-instead" data-id="${esc(swapCandidate.id)}">Swap instead</button></span></div>` : ""}
      ${S.flow.reason ? `<label class="tk9oh__field" style="margin-top:18px"><span class="tk9oh__label">Anything we should know? <small>Optional</small></span>
        <textarea class="tk9oh__textarea" data-bind="note" maxlength="500" placeholder="A quick note helps">${esc(S.flow.note || "")}</textarea></label>` : ""}
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="next" ${S.flow.reason ? "" : "disabled"}>Continue</button></div>`;
  }

  function returnConfirm() {
    const lines = Object.entries(S.flow.sel).map(([id, qty]) => ({ item: itemById(id), qty, parts: S.flow.parts[id] }));
    const total = lines.reduce((sum, line) => sum + line.item.unitPaid * line.qty, 0);
    const partial = partialReturn();
    S.flow.ref = S.flow.ref || ref("ret");
    const label = (line) => {
      if (!line.item.bundle) return esc(line.item.title);
      if (line.parts) return `${esc(line.item.title)}<br><small>${esc(line.item.bundle.components.filter((c) => line.parts.has(c.key)).map((c) => c.label).join(", "))} only</small>`;
      return `${esc(line.item.title)}<br><small>Whole ${esc(line.item.bundle.kind)}</small>`;
    };
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Review your return</h2>
      <div class="tk9oh__summary">
        ${lines.map((line) => `<div><span>${label(line)}${line.qty > 1 ? ` × ${line.qty}` : ""}</span><b>${line.parts ? "—" : money(line.item.unitPaid * line.qty)}</b></div>`).join("")}
        <div><span>Return shipping</span><b>Paid by you</b></div>
        <div class="is-total"><span>Refund once it arrives</span><b>${partial ? "We'll confirm" : money(total)}</b></div>
      </div>
      ${partial ? `<div class="tk9oh__note">${ic("box")}<span>Returning part of a kit — we'll email your refund amount for the parts you send back.</span></div>` : ""}
      <ol class="tk9oh__steps">
        <li><span>Pack it like new.</span></li>
        <li><span>Write <b>${pii(`RMA - ${esc(num(S.data.order.name))}`)}</b> on the box.</span></li>
        <li><span>Ship it to our Golden, CO office — address on the next screen.</span></li>
      </ol>
      ${!S.data.live && !partial ? `<div class="tk9oh__note">${ic("chat")}<span>Our team will confirm by email.</span></div>` : ""}
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="submit-return">Start return</button></div>
      ${errorBox()}`;
  }

  async function submitReturn(btn) {
    await busy(btn, async () => {
      const items = Object.entries(S.flow.sel).map(([id, qty]) => ({ id, qty, parts: S.flow.parts[id] ? Array.from(S.flow.parts[id]) : undefined }));
      const result = await api("return", { items, reason: S.flow.reason, note: S.flow.note || "", ref: S.flow.ref });
      S.result = result;
      go("done");
    });
  }

  // Claim ---------------------------------------------------------------
  const CLAIMS = [
    ["damaged", "Arrived damaged", "broken"],
    ["defective", "Broke or stopped working", "alert"],
    ["wrong_item", "Wrong item", "wrong"],
    ["missing", "Something's missing", "missing"],
    ["not_received", "Says delivered, but it's not here", "truck"],
    ["other", "Something else", "chat"]
  ];
  const needsPhotos = (type) => ["damaged", "defective", "wrong_item"].includes(type);

  function claimType() {
    const delivered = deliveredPackages().length > 0;
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>What happened?</h2>
      <p class="tk9oh__p">Tell us what happened and our team will review it.</p>
      <div class="tk9oh__options">${CLAIMS.filter(([key]) => key !== "not_received" || delivered).map(([key, label, icon]) => `
        <button type="button" class="tk9oh__option" data-act="claim-type" data-type="${key}">
          <span class="tk9oh__tile-icon tk9oh__tile-icon--amber">${ic(icon)}</span><b>${esc(label)}</b><span class="tk9oh__chev">${ic("chev")}</span>
        </button>`).join("")}</div>`;
  }

  function claimItems() {
    if (S.flow.type === "not_received") {
      return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Which package?</h2>
        <div class="tk9oh__items">${deliveredPackages().map((pkg) => {
          const first = itemById((pkg.items[0] || {}).id) || {};
          return `<button type="button" class="tk9oh__item${S.flow.packageId === pkg.id ? " is-selected" : ""}" data-act="claim-pkg" data-id="${esc(pkg.id)}">
            <span class="tk9oh__item-img">${img(first.image)}</span>
            <span class="tk9oh__item-body"><b>${esc(pkg.carrier || "Package")} · delivered ${esc(day(pkg.deliveredAt))}</b><span>${plural(pkg.items.length, "item")} · ${pii(esc(pkg.number || ""))}</span></span>
            <span class="tk9oh__check">${ic("check")}</span></button>`;
        }).join("")}</div>
        <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="next" ${S.flow.packageId ? "" : "disabled"}>Continue</button></div>`;
    }
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Which item${S.flow.type === "missing" ? " is missing" : ""}?</h2>
      <p class="tk9oh__p">Pick all that apply.</p>
      <div class="tk9oh__items">${physical().map((item) => itemCard(item, {
        act: "claim-item",
        multi: true,
        selected: S.flow.items.has(item.id),
        extra: item.bundle && S.flow.items.has(item.id) ? `<span class="tk9oh__parts-label">Which part?</span>${partChips(item, S.flow.parts[item.id], "claim-part")}` : ""
      })).join("")}</div>
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="next" ${S.flow.items.size ? "" : "disabled"}>Continue</button></div>`;
  }

  function claimDetails() {
    const required = needsPhotos(S.flow.type);
    const photos = S.flow.photos;
    const slots = [];
    for (let i = 0; i < 4; i += 1) {
      if (photos[i]) slots.push(`<div class="tk9oh__photo is-filled rr-block" data-watch-block><img src="${photos[i]}" alt="Photo ${i + 1}"><button type="button" data-act="photo-remove" data-index="${i}" aria-label="Remove photo">${ic("close")}</button></div>`);
      else if (i === photos.length) slots.push(`<label class="tk9oh__photo">${ic(i === 0 ? "camera" : "plus")}<span class="tk9oh__sr">Add photo</span><input type="file" accept="image/*" data-photo ${i === 0 ? "" : "multiple"}></label>`);
    }
    S.flow.ref = S.flow.ref || ref("clm");
    const label = (CLAIMS.find(([key]) => key === S.flow.type) || [])[1] || "";
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>${required ? "Show us" : "Tell us a bit more"}</h2>
      <p class="tk9oh__p">${esc(label)}${required ? " — a photo or two is all we need." : ""}</p>
      ${required || S.flow.type === "missing" || S.flow.type === "other" ? `<span class="tk9oh__label">Photos <small>${required ? "Required" : "Optional — the box or packing slip helps"}</small></span><div class="tk9oh__photos">${slots.join("")}</div>` : ""}
      <label class="tk9oh__field" style="margin-top:16px"><span class="tk9oh__label">What happened? ${required ? "<small>Optional</small>" : ""}</span>
        <textarea class="tk9oh__textarea" data-bind="note" maxlength="1500" placeholder="${S.flow.type === "not_received" ? "Checked with neighbors / mailroom?" : "A sentence or two"}">${esc(S.flow.note || "")}</textarea></label>
      ${S.data.order.protectedShipping && S.flow.type === "not_received" ? `<div class="tk9oh__note">${ic("shield")}<span>Your order has <b>shipping protection</b>.</span></div>` : ""}
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="submit-claim" ${required && !photos.length ? "disabled" : ""}>Send to our team</button></div>
      ${errorBox()}`;
  }

  async function addPhotos(input) {
    const files = Array.from(input.files || []).slice(0, 4 - S.flow.photos.length);
    for (const file of files) {
      try {
        S.flow.photos.push(await compress(file));
      } catch (error) {
        S.error = error.message;
      }
    }
    render();
  }

  function compress(file) {
    return new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();
      image.onload = () => {
        const max = 1600;
        const scale = Math.min(1, max / Math.max(image.naturalWidth, image.naturalHeight));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(image.naturalWidth * scale);
        canvas.height = Math.round(image.naturalHeight * scale);
        canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/jpeg", 0.82));
      };
      image.onerror = () => { URL.revokeObjectURL(url); reject(new Error("We couldn't read that photo. Try a JPG or PNG.")); };
      image.src = url;
    });
  }

  async function submitClaim(btn) {
    await busy(btn, async () => {
      const result = await api("claim", {
        type: S.flow.type,
        items: Array.from(S.flow.items),
        parts: Object.fromEntries(Object.entries(S.flow.parts).map(([id, set]) => [id, Array.from(set)])),
        packageId: S.flow.packageId || undefined,
        note: S.flow.note || "",
        photos: S.flow.photos,
        ref: S.flow.ref
      });
      S.result = result;
      go("done");
    });
  }

  // Episode help --------------------------------------------------------
  function episodeDetails() {
    const list = episodes();
    const picked = S.flow.itemId ? itemById(S.flow.itemId) : null;
    S.flow.ref = S.flow.ref || ref("eph");
    const fix = picked && picked.episode.ready && !picked.episode.refunded ? picked : list.find((item) => item.episode.ready && !item.episode.refunded);
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>How can we help?</h2>
      <p class="tk9oh__p">Tell us what's wrong and our team will reply by email.</p>
      ${fix ? `<div class="tk9oh__note tk9oh__note--accent">${ic("info")}<span><b>Fastest fix:</b> on the episode page, tap <b>Not right?</b> to make it again for free or get a refund on the spot. <a class="tk9oh__link" href="${esc(fix.episode.fixUrl)}" target="_blank" rel="noopener" data-act="episode-open" data-what="fix">Open it</a></span></div>` : ""}
      ${list.length > 1 ? `<span class="tk9oh__label" style="margin-top:18px">Which episode?</span>
        <div class="tk9oh__items">${list.map((item) => `<div role="radio" aria-checked="${S.flow.itemId === item.id ? "true" : "false"}" tabindex="0" class="tk9oh__item${S.flow.itemId === item.id ? " is-selected" : ""}" data-act="episode-item" data-id="${esc(item.id)}">
          <span class="tk9oh__item-img tk9oh__thumb--episode">${ic("playsolid")}</span>
          <span class="tk9oh__item-body"><b>${esc(item.title)}</b><span>${esc(item.detail)}</span></span>
          <span class="tk9oh__check">${ic("check")}</span></div>`).join("")}</div>` : ""}
      <label class="tk9oh__field" style="margin-top:16px"><span class="tk9oh__label">Your message</span>
        <textarea class="tk9oh__textarea" data-bind="note" maxlength="1500" placeholder="A sentence or two">${esc(S.flow.note || "")}</textarea></label>
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="submit-episode" ${list.length > 1 && !S.flow.itemId ? "disabled" : ""}>Send to our team</button></div>
      ${errorBox()}`;
  }

  async function submitEpisode(btn) {
    await busy(btn, async () => {
      const itemId = S.flow.itemId;
      S.result = { ...(await api("episode_help", { itemId: itemId || undefined, note: S.flow.note || "", ref: S.flow.ref })), itemId };
      go("done");
    });
  }

  // Track ---------------------------------------------------------------
  const TIMELINE = ["Ordered", "Shipped", "Out for delivery", "Delivered"];
  /** How many timeline steps are complete for a package status. */
  function timelineDone(status) {
    return { preparing: 1, packed: 1, transit: 2, attention: 2, out: 3, delivered: 4 }[status] ?? 2;
  }

  function trackList() {
    const pkgs = S.data.packages;
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>${pkgs.length > 1 ? `${pkgs.length} packages` : "Your package"}</h2>
      <p class="tk9oh__p">${pkgs.length > 1 ? "Items can ship separately — custom patches always do." : "Here's where it is."}</p>
      ${pkgs.map((pkg, index) => {
        const done = timelineDone(pkg.status);
        const items = pkg.items.map((entry) => itemById(entry.id)).filter(Boolean);
        const when = pkg.status === "delivered" ? `Delivered ${day(pkg.deliveredAt)}`
          : pkg.status === "preparing" ? (S.data.order.stage === "before_export" ? "Not shipped yet" : "Packing now")
          : pkg.eta ? `Expected ${day(pkg.eta)}` : pkg.shippedAt ? `Shipped ${day(pkg.shippedAt)}` : "";
        return `<div class="tk9oh__pkg">
          <div class="tk9oh__pkg-head"><div><b>${pkgs.length > 1 ? `Package ${index + 1}` : esc(pkg.label)}</b><span>${esc(when)}${pkg.lastEvent && pkg.lastEvent.where && pkg.status !== "delivered" ? ` · ${esc(pkg.lastEvent.where)}` : ""}</span></div>
          <span class="tk9oh__pill tk9oh__pill--${esc(pkg.status)}">${esc(pkg.label)}</span></div>
          <div class="tk9oh__timeline">${TIMELINE.map((label, i) => `<div class="${i < done ? "is-done" : i === done ? "is-now" : ""}">${label}</div>`).join("")}</div>
          <div class="tk9oh__thumbs">${items.map((item) => `<div class="tk9oh__thumb" title="${esc(item.title)}">${img(item.image, item.title)}</div>`).join("")}</div>
          <div class="tk9oh__pkg-foot">
            ${pkg.number ? `<span class="tk9oh__mono">${esc(pkg.carrier)} ${pii(esc(pkg.number))}</span>` : "<span></span>"}
            ${pkg.url ? `<a href="${esc(pkg.url)}" target="_blank" rel="noopener">Carrier tracking ${ic("ext")}</a>` : ""}
            ${pkg.status === "delivered" ? `<button type="button" class="tk9oh__link" data-act="not-here" data-id="${esc(pkg.id)}">Not there?</button>` : ""}
          </div>
        </div>`;
      }).join("")}`;
  }

  // Cancel --------------------------------------------------------------
  const CANCEL_REASONS = ["Ordered by mistake", "Wrong size or color", "Changed my mind", "Other"];
  // "Cancel order" on an order that has shipped but not arrived: say plainly that it cannot be stopped, then the way out.
  function onwayInfo() {
    const pkg = S.data.packages.find((p) => !p.deliveredAt) || {};
    const track = `<button type="button" class="tk9oh__btn tk9oh__btn--ghost" data-act="onway-track">Track package</button>`;
    if (S.data.cancel.askedBefore === "confirmed") {
      return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Your order is already on its way</h2>
        <p class="tk9oh__p">You asked us to cancel this order before it shipped, and it went out anyway. We're sorry about that.</p>
        <p class="tk9oh__p">Reply to your cancellation conversation and our team will help you with the return.</p>
        <div class="tk9oh__actions">${track}</div>`;
    }
    if (S.data.cancel.askedBefore) {
      return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Your order is already on its way</h2>
        <p class="tk9oh__p">Our team needs to review your earlier message before helping with this return.</p>
        <p class="tk9oh__p">Reply to that conversation and our team will help you.</p>
        <div class="tk9oh__actions">${track}</div>`;
    }
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Your order is already on its way</h2>
      <p class="tk9oh__p">It shipped${pkg.shippedAt ? ` on ${day(pkg.shippedAt)}` : ""}, so it can't be cancelled.${S.data.cancel.late ? " We're sorry it's taking this long." : ""}</p>
      <p class="tk9oh__p">If you no longer want it, start a return now and send it back when it arrives. After your return arrives, we'll issue the refund to your original payment method.</p>
      <p class="tk9oh__p">If you think it's lost, choose Report a problem.</p>
      <div class="tk9oh__actions">
        <button type="button" class="tk9oh__btn" data-act="onway-return">Start a return</button>
        ${track}
        <button type="button" class="tk9oh__btn tk9oh__btn--ghost" data-act="onway-claim">Report a problem</button>
      </div>`;
  }

  function cancelConfirm() {
    const auto = S.data.cancel.mode === "auto" && S.data.live;
    S.flow.ref = S.flow.ref || ref("cxl");
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Cancel order ${pii(esc(S.data.order.name))}?</h2>
      <p class="tk9oh__p">${auto ? "It hasn't shipped, so you'll get a full refund." : "It's with our warehouse — we'll try to stop it before it ships."}</p>
      ${auto ? `<div class="tk9oh__summary"><div><span>Refund to original payment</span><b>${money(S.data.order.total)}</b></div></div>` : ""}
      ${swappable().length ? `<div class="tk9oh__note tk9oh__note--accent">${ic("swap")}<span>Just the wrong size? <button type="button" class="tk9oh__link" data-act="start" data-flow="swap">Change the size instead</button></span></div>` : ""}
      <div class="tk9oh__section-label">Reason <span style="text-transform:none;font-weight:500">(optional)</span></div>
      <div class="tk9oh__chips">${CANCEL_REASONS.map((reason) => `<button type="button" class="tk9oh__chip${S.flow.reason === reason ? " is-selected" : ""}" data-act="cancel-reason" data-reason="${esc(reason)}">${esc(reason)}</button>`).join("")}</div>
      <div class="tk9oh__actions">
        <button type="button" class="tk9oh__btn tk9oh__btn--danger" data-act="submit-cancel">${auto ? "Cancel order" : "Request cancellation"}</button>
        <button type="button" class="tk9oh__btn tk9oh__btn--ghost" data-act="home">Keep my order</button>
      </div>
      ${errorBox()}`;
  }

  async function submitCancel(btn) {
    await busy(btn, async () => {
      S.result = await api("cancel", { reason: S.flow.reason || "", ref: S.flow.ref });
      go("done");
    });
  }

  // Address -------------------------------------------------------------
  function addressForm() {
    const a = S.flow.addr || {};
    const field = (key, label, attrs = "") => `<label class="tk9oh__field"><span class="tk9oh__label">${label}</span><input class="tk9oh__input" data-bind-addr="${key}" value="${esc(a[key] || "")}" ${attrs}></label>`;
    S.flow.ref = S.flow.ref || ref("adr");
    return `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>Where should it go?</h2>
      <p class="tk9oh__p">${S.data.address.mode === "auto" && S.data.live ? "Confirm to update the address on your order." : "Our team will review your change request and reply by email."}</p>
      <div class="tk9oh__row">${field("firstName", "First name", 'autocomplete="given-name"')}${field("lastName", "Last name", 'autocomplete="family-name"')}</div>
      ${field("address1", "Street address", 'autocomplete="address-line1"')}
      ${field("address2", "Apt, suite <small>Optional</small>", 'autocomplete="address-line2"')}
      <div class="tk9oh__row tk9oh__row--3">${field("city", "City", 'autocomplete="address-level2"')}${field("provinceCode", "State", 'autocomplete="address-level1" maxlength="3" placeholder="TX"')}${field("zip", "ZIP", 'autocomplete="postal-code" inputmode="numeric"')}</div>
      ${field("phone", "Phone <small>Optional</small>", 'autocomplete="tel" inputmode="tel"')}
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="submit-address">Save address</button></div>
      ${errorBox()}`;
  }

  async function submitAddress(btn) {
    await busy(btn, async () => {
      S.result = await api("address", { address: S.flow.addr, ref: S.flow.ref });
      go("done");
    });
  }

  // Tracking on a return ------------------------------------------------
  function trackingForm(returnId) {
    return `<form class="tk9oh__field" data-form="tracking" data-return="${esc(returnId)}" style="margin-top:18px">
      <label class="tk9oh__label" for="tk9oh-return-tracking">Return shipment tracking number</label>
      <p class="tk9oh__p" id="tk9oh-return-tracking-help">After you ship your items back to Team K9, enter the new tracking number from your return shipping receipt or label. <strong>Do not use the tracking number from your original delivery.</strong></p>
      <p class="tk9oh__p" id="tk9oh-return-tracking-later">Haven't shipped your return yet? Come back after you send it.</p>
      <div class="tk9oh__inline-form"><input class="tk9oh__input" id="tk9oh-return-tracking" name="number" aria-describedby="tk9oh-return-tracking-help tk9oh-return-tracking-later" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Return tracking number" required><button class="tk9oh__btn" type="submit">Save return tracking</button></div>
    </form>`;
  }

  // ------------------------------------------------------------------ done
  const mark = (wait) => `<svg class="tk9oh__done-mark${wait ? " tk9oh__done-mark--wait" : ""}" viewBox="0 0 76 76" aria-hidden="true"><circle cx="38" cy="38" r="38"/><path d="${wait ? "M38 22v18l11 7" : "M24 39l10 10 19-21"}"/></svg>`;

  function viewDone() {
    const html = doneBody();
    const r = S.result || {};
    return r.kind === "preview" ? html : html.replace(/<\/div>\s*$/, `${feedbackBlock()}</div>`);
  }

  // One tap after every outcome; "Okay"/"Hard" invites a short note.
  const RATINGS = [["easy", "Easy"], ["okay", "Okay"], ["hard", "Hard"]];
  function feedbackKey() {
    const r = S.result || {};
    return r.ref || `${r.kind || ""}:${S.data && S.data.order ? S.data.order.name : ""}`;
  }
  function feedbackBlock() {
    const fb = S.feedback && S.feedback.key === feedbackKey() ? S.feedback : {};
    if (fb.sent) return `<p class="tk9oh__rate tk9oh__rate--done" role="status">Thanks — that helps us make this better.</p>`;
    if (fb.score && fb.score !== "easy") {
      return `<form class="tk9oh__rate" data-form="feedback">
        <label class="tk9oh__rate-q" for="tk9oh-rate-note">What would have made it easier?</label>
        <textarea class="tk9oh__input tk9oh__rate-note" id="tk9oh-rate-note" name="comment" rows="2" maxlength="400" placeholder="Optional"></textarea>
        <div class="tk9oh__rate-row"><button class="tk9oh__btn" type="submit">Send</button><button type="button" class="tk9oh__link" data-act="rate-skip">Skip</button></div>
      </form>`;
    }
    return `<div class="tk9oh__rate" role="group" aria-labelledby="tk9oh-rate-q">
      <span class="tk9oh__rate-q" id="tk9oh-rate-q">How was this?</span>
      <div class="tk9oh__rate-row">${RATINGS.map(([key, label]) => `<button type="button" class="tk9oh__chip" data-act="rate" data-score="${key}">${label}</button>`).join("")}</div>
    </div>`;
  }
  function sendFeedback(extra) {
    const r = S.result || {};
    if (cfg.demo || !cfg.api) return;
    try {
      fetch(cfg.api, { method: "POST", keepalive: true, headers: { "content-type": "text/plain" }, body: JSON.stringify({ action: "feedback", token: S.token || undefined, ref: r.ref, kind: r.kind, ...extra }) }).catch(() => {});
    } catch {}
  }
  function swapFeedback(from) {
    const box = from.closest(".tk9oh__rate");
    if (!box) return;
    box.outerHTML = feedbackBlock();
    const note = root.querySelector(".tk9oh__rate-note");
    if (note) note.focus();
  }

  function doneBody() {
    const r = S.result || {};
    const backBtn = `<div class="tk9oh__actions"><button type="button" class="tk9oh__btn tk9oh__btn--ghost" data-act="home">Back to my order</button></div>`;
    const title = (text) => `<h2 class="tk9oh__h" tabindex="-1" data-autofocus>${text}</h2>`;

    if (r.kind === "preview") {
      return `<div class="tk9oh__done">${mark(true)}${title("Preview only")}
        <p class="tk9oh__p">Nothing was changed. Here's what would happen:</p>
        <div class="tk9oh__summary">${Object.entries(r.plan || {}).filter(([, v]) => v !== null && v !== "" && typeof v !== "object").map(([k, v]) => `<div><span>${esc(k)}</span><b>${esc(v)}</b></div>`).join("")}</div>
        ${backBtn}</div>`;
    }
    switch (r.kind) {
      case "fit_fixed": {
        const days = r.item && r.item.daysLeft > 0 ? r.item.daysLeft : 0;
        return `<div class="tk9oh__done">${mark()}${title("Glad it fits!")}
          <p class="tk9oh__p">Enjoy the walks.${days ? ` If anything changes, your free swap is good for ${days} more day${days === 1 ? "" : "s"}.` : ""}</p>${backBtn}</div>`;
      }
      case "exchange":
        if (r.giveBack) {
          return `<div class="tk9oh__done">${mark()}${title(r.kept && r.kept.length
            ? `Your new ${esc(r.swapped.join(" + ").toLowerCase())} ${r.swapped.length > 1 ? "are" : "is"} on the way`
            : `Your ${esc(r.size)} is on the way`)}
            <p class="tk9oh__p">Swap order <b>${pii(esc(r.exchangeOrder || ""))}</b> is in.</p>
            <ol class="tk9oh__steps">
              <li><span><b>New size ships free.</b> You'll get a tracking email when it ships.</span></li>
              <li><span><b>No need to send the old one back.</b>${r.kept && r.kept.length ? ` Keep your ${esc(r.kept.join(" and "))}, too.` : ""} ${GIVE_BACK}</span></li>
            </ol>
            <p class="tk9oh__emailed">${ic("chat")}We've emailed you a copy.</p>${backBtn}</div>`;
        }
        return `<div class="tk9oh__done">${mark()}${title(r.kept && r.kept.length
          ? `Your new ${esc(r.swapped.join(" + ").toLowerCase())} ${r.swapped.length > 1 ? "are" : "is"} on the way`
          : `Your ${esc(r.size)} is on the way`)}
          <p class="tk9oh__p">Swap order <b>${pii(esc(r.exchangeOrder || ""))}</b> is in. Watch your inbox for the free return label.</p>
          <ol class="tk9oh__steps">
            <li><span><b>New size ships free.</b> You'll get a tracking email when it ships.</span></li>
            <li><span><b>Return label</b> arrives by email.</span></li>
            <li><span>${r.kept && r.kept.length ? `Send back just the old ${esc(r.swapped.join(" + ").toLowerCase())} — keep your ${esc(r.kept.join(" and "))}.` : "Drop the old one in the mail with it."}</span></li>
          </ol>
          ${r.priceDelta < 0 ? `<div class="tk9oh__note">${ic("check")}<span>We'll refund the ${money(Math.abs(r.priceDelta))} difference once your original arrives.</span></div>` : ""}
          <p class="tk9oh__emailed">${ic("chat")}We've emailed you a copy.</p>${backBtn}</div>`;
      case "upgrade":
        return `<div class="tk9oh__done">${mark()}${title("Check your email")}
          <p class="tk9oh__p">We sent a secure invoice for the ${money(r.priceDelta)} difference. Payment is required before your ${esc(r.size)} can ship. Our team will also email a free return label for the original.</p>${backBtn}</div>`;
      case "edited":
        return `<div class="tk9oh__done">${mark()}${title("Size updated")}
          <p class="tk9oh__p">Your order now has the <b>${esc(r.size)}</b>. Nothing else to do.</p>${backBtn}</div>`;
      case "return":
        return `<div class="tk9oh__done">${mark()}${title("Return started")}
          <p class="tk9oh__p">${r.awaitingDelivery
            ? "If your package hasn't reached you yet, you can send the items back once it arrives. If you're concerned about the delivery, reply to the email we just sent you. After your return arrives, we'll issue the refund to your original payment method."
            : "Send the items back. After they arrive, we'll issue the refund to your original payment method."}</p>
          ${rmaCard(r)}
          ${r.returnId ? trackingForm(r.returnId) : ""}
          <p class="tk9oh__emailed">${ic("chat")}We've emailed you these steps and a link back here.</p>${backBtn}</div>`;
      case "return_requested":
        if (r.teamHelping) return alreadyHelping();
        return `<div class="tk9oh__done">${mark(true)}${title("Return request sent")}
          <p class="tk9oh__p">We'll confirm by email. Here's where it goes:</p>${rmaCard(r)}${backBtn}</div>`;
      case "tracking_added":
        return `<div class="tk9oh__done">${mark()}${title("Return tracking saved")}
          <p class="tk9oh__p">Thanks. Your return shipment tracking has been saved.</p>${backBtn}</div>`;
      case "claim":
        if (r.replacement) {
          return `<div class="tk9oh__done">${mark()}${title("Replacement order created")}
            <p class="tk9oh__p">We've created a replacement order for you at no charge: <b>${pii(esc(r.replacement))}</b>. There's no need to send the first one back.</p>
            <p class="tk9oh__emailed">${ic("chat")}We've emailed you a copy. You'll get a tracking email when it ships.</p>${backBtn}</div>`;
        }
        return `<div class="tk9oh__done">${mark()}${title("We're on it")}
          <p class="tk9oh__p">Our team will review it and reply by email.</p>
          ${r.ticket ? `<span class="tk9oh__ref">Reference <b>${pii(`#${esc(r.ticket)}`)}</b></span>` : ""}<p class="tk9oh__emailed">${ic("chat")}We've emailed you a confirmation.</p>${backBtn}</div>`;
      case "episode_help": {
        const list = episodes().filter((item) => item.episode.ready && !item.episode.refunded && (!r.itemId || item.id === r.itemId));
        return `<div class="tk9oh__done">${mark()}${title("Message sent")}
          <p class="tk9oh__p">Our team will reply by email. ${list.length ? "If it's the episode itself, you don't have to wait: its page can make it again for free or refund it right now." : ""}</p>
          ${list.map((item) => `<a class="tk9oh__episode-fix tk9oh__episode-fix--done" href="${esc(item.episode.fixUrl)}" target="_blank" rel="noopener" data-act="episode-open" data-what="fix"><span><b>Not right?</b> ${list.length > 1 ? esc(item.title) : "Make it again or get a refund"}</span>${ic("chev")}</a>`).join("")}
          ${r.ticket ? `<span class="tk9oh__ref">Reference <b>${pii(`#${esc(r.ticket)}`)}</b></span>` : ""}<p class="tk9oh__emailed">${ic("chat")}We've emailed you the episode link too.</p>${backBtn}</div>`;
      }
      case "ships_separately":
        return `<div class="tk9oh__done">${mark(true)}${title("Good news — it's coming")}
          <p class="tk9oh__p">${esc((r.items || []).join(", "))} ${r.items && r.items.length > 1 ? "haven't" : "hasn't"} shipped yet. It ships on its own with separate tracking.</p>
          <div class="tk9oh__actions"><button type="button" class="tk9oh__btn" data-act="start" data-flow="track">See tracking</button></div>${backBtn}</div>`;
      case "cancelled":
        return `<div class="tk9oh__done">${mark()}${title("Order cancelled")}
          <p class="tk9oh__p">Your ${money(r.total)} refund is on its way — it usually shows in 1–3 business days.</p>${backBtn}</div>`;
      case "cancel_requested":
        return `<div class="tk9oh__done">${mark(true)}${title("Cancellation requested")}
          <p class="tk9oh__p">${r.exported ? "Your request is with our team, and they will reply by email." : "We'll confirm by email."}</p>${backBtn}</div>`;
      case "address_updated":
        return `<div class="tk9oh__done">${mark()}${title("Address updated")}
          <p class="tk9oh__p">It'll ship to <b>${pii(esc(r.address))}</b>.</p>${backBtn}</div>`;
      case "address_requested":
        return `<div class="tk9oh__done">${mark(true)}${title("Got it")}
          <p class="tk9oh__p">We've sent your new address to our warehouse and will confirm by email.</p>${backBtn}</div>`;
      default:
        if (r.teamHelping) return alreadyHelping();
        return `<div class="tk9oh__done">${mark(true)}${title("Request sent")}
          <p class="tk9oh__p">Our team will confirm by email.</p>${backBtn}</div>`;
    }
  }

  function alreadyHelping() {
    return `<div class="tk9oh__done">${mark(true)}<h2 class="tk9oh__h" tabindex="-1" data-autofocus>We're already on it</h2>
      <p class="tk9oh__p">Our team is already helping with this order, so we've added your request to that conversation instead of starting a new one. We'll reply there.</p>
      <div class="tk9oh__actions"><button type="button" class="tk9oh__btn tk9oh__btn--ghost" data-act="home">Back to my order</button></div></div>`;
  }

  function rmaCard(r) {
    const a = r.address || S.data.returnAddress;
    const rma = r.rma || `RMA - ${num(S.data.order.name)}`;
    return `<div class="tk9oh__rma">
      <div class="tk9oh__rma-top"><div><small>Write on the box</small><strong>${pii(esc(rma))}</strong></div>
      <button type="button" class="tk9oh__copy" data-act="copy" data-copy="${esc(`${rma}\n${a.name}\n${a.line1}\n${a.line2}`)}">${ic("copy")}<span>Copy</span></button></div>
      <address>${esc(a.name)}<br>${esc(a.line1)}<br>${esc(a.line2)}</address>
    </div>`;
  }

  async function refreshHome() {
    if (cfg.demo || !S.token) return go("home", null, "back");
    try {
      const data = await api("order", {});
      S.data = { ...data, token: S.token };
    } catch (error) {
      if (error.status === 401) return expired();
    }
    go("home", null, "back");
  }

  function expired() {
    S.token = null;
    S.data = null;
    S.view = "find";
    S.error = "Your session timed out. Please look up your order again.";
    S.dir = "back";
    render();
  }

  // ------------------------------------------------------------------ Merchanting Watch
  // The Watch recorder loads late (and only with analytics consent), so calls queue until it's there.
  // Component ids are enumerated (no text or values); Watch keys them as tk9oh.<id>.
  const watchQueue = [];
  let watchTimer = null;
  function watchFlush() {
    const recorder = window.MerchantingWatch;
    if (!recorder || typeof recorder.track !== "function") return false;
    while (watchQueue.length) {
      const details = watchQueue.shift();
      try { recorder.track("element_action", details); } catch {}
    }
    return true;
  }
  function watch(kind, action, id) {
    if (cfg.demo) return;
    watchQueue.push({ kind, action, component_id: `tk9oh.${id}`.toLowerCase().replace(/[^a-z0-9_.:-]/g, "_").slice(0, 100) });
    if (watchQueue.length > 80) watchQueue.shift();
    if (watchFlush() || watchTimer) return;
    let tries = 0;
    watchTimer = setInterval(() => {
      tries += 1;
      if (watchFlush() || tries > 40) { clearInterval(watchTimer); watchTimer = null; }
    }, 1500);
  }
  const WATCH_BEACONS = {
    fit_video: ["video", "play", "fit.video"],
    fit_guide: ["size_guide", "open", "fit.guide"],
    fit_fixed: ["quiz", "complete", "fit.fixed"],
    nudge_shown: ["offer", "open", "nudge"],
    nudge_swap: ["offer", "complete", "nudge"],
    nudge_return: ["offer", "change", "nudge"],
    nudge_fit: ["offer", "click", "nudge"]
  };
  const REQUEST_KINDS = new Set(["request", "cancel_requested", "address_requested", "return_requested"]);
  let lastFlow = "";
  let lastScreen = "";
  let lastError = "";
  function watchScreen() {
    const screen = S.view === "flow" && S.flow ? `step.${S.flow.kind}.${S.flow.step}` : S.view === "done" ? `done:${(S.result || {}).kind || ""}` : S.view;
    if (S.error && S.error !== lastError) watch("copy", "open", "error");
    lastError = S.error || "";
    if (screen === lastScreen) return;
    lastScreen = screen;
    if (S.view === "find") watch("quiz", "open", "lookup");
    else if (S.view === "flow" && S.flow) watch("quiz", "open", screen);
    else if (S.view === "done") {
      const r = S.result || {};
      if (r.kind && r.kind !== "preview") watch("quiz", "complete", `${REQUEST_KINDS.has(r.kind) || r.teamHelping ? "request" : "flow"}.${lastFlow || "unknown"}`);
    }
  }

  // ------------------------------------------------------------------ usage beacons
  function beacon(event, extra = {}) {
    if (WATCH_BEACONS[event]) watch(...WATCH_BEACONS[event]);
    if (cfg.demo || !cfg.api) return;
    try {
      fetch(cfg.api, { method: "POST", keepalive: true, headers: { "content-type": "text/plain" }, body: JSON.stringify({ action: "track", event, token: S.token || undefined, ...extra }) }).catch(() => {});
    } catch {}
  }

  // ------------------------------------------------------------------ api
  async function api(action, payload) {
    if (cfg.demo) return demoApi(action, payload);
    const body = { action, token: S.token || undefined, watchSession: (window.MerchantingWatch && window.MerchantingWatch.sessionId) || undefined, ...payload };
    if (cfg.preview && action !== "lookup" && action !== "order") body.preview = true;
    let response;
    try {
      response = await fetch(cfg.api, { method: "POST", headers: { "content-type": "application/json" }, body: JSON.stringify(body) });
    } catch {
      throw Object.assign(new Error("We couldn't reach our servers. Check your connection and try again."), { status: 0 });
    }
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(data.message || "Something went wrong. Please try again."), { status: response.status, code: data.error });
    return data;
  }

  async function busy(btn, fn) {
    if (btn) { btn.classList.add("is-busy"); btn.disabled = true; }
    try {
      await fn();
    } catch (error) {
      if (error.status === 401) return expired();
      S.error = error.message;
      render();
    } finally {
      if (btn && btn.isConnected) { btn.classList.remove("is-busy"); btn.disabled = false; }
    }
  }

  // ------------------------------------------------------------------ events
  root.addEventListener("click", (event) => {
    const el = event.target.closest("[data-act]");
    if (!el || !root.contains(el)) return;
    const act = el.dataset.act;
    const f = S.flow;
    switch (act) {
      case "back": return back();
      case "home": return S.view === "flow" || S.view === "done" ? refreshHome() : go("home", null, "back");
      case "restart": S.data = null; S.token = null; return go("find", null, "back");
      case "restart-email": S.data = null; S.token = null; S.via = "email"; return go("find", null, "back");
      case "toggle-id": S.via = S.via === "email" ? "zip" : "email"; S.error = ""; return render();
      case "recent": return lookup(null, el.dataset.order, cfg.customerEmail);
      case "demo-order": return lookup(el, el.dataset.order, "demo@teamk9.com");
      case "start": return startFlow(el.dataset.flow);
      case "next": {
        const steps = activeSteps(f);
        return step(steps[steps.indexOf(f.step) + 1]);
      }
      case "swap-item": {
        f.itemId = el.dataset.id; f.size = null; f.collarSize = null; f.issue = null; f.skipFit = false; f.fitShown = false;
        const steps = activeSteps(f);
        return step(steps[steps.indexOf("item") + 1]);
      }
      case "fit-issue": f.issue = el.dataset.issue; return step(activeSteps(f).includes("fix") ? "fix" : "size");
      case "fit-still": return step("size");
      case "sizer-pick": f.size = el.dataset.size; return step("size");
      case "swap-keep": f.sendBack = false; return render();
      case "swap-back": f.sendBack = true; return render();
      case "fit-return": {
        const id = f.itemId;
        startFlow("return");
        S.flow.sel = { [id]: 1 };
        S.flow.reason = f.issue === "too_small" ? "too_small" : "too_big";
        return step("reason");
      }
      case "fit-fixed": {
        const item = itemById(f.itemId);
        beacon("fit_fixed", { family: item.family, issue: f.issue });
        S.result = { kind: "fit_fixed", item };
        return go("done");
      }
      case "media": return openMedia(el.dataset.index);
      case "swap-size": f.size = f.size === el.dataset.size && isKitSwap(itemById(f.itemId)) ? null : el.dataset.size; return render();
      case "swap-collar": f.collarSize = el.dataset.size || null; return render();
      case "submit-swap": return submitSwap(el);
      case "return-item": {
        if (event.target.closest("[data-stop]")) return;
        const id = el.dataset.id;
        if (f.sel[id]) delete f.sel[id];
        else f.sel[id] = 1;
        return render();
      }
      case "qty": {
        event.stopPropagation();
        const item = itemById(el.dataset.id);
        f.sel[item.id] = Math.min(item.return.maxQty, Math.max(1, (f.sel[item.id] || 1) + Number(el.dataset.d)));
        return render();
      }
      case "reason": f.reason = el.dataset.reason; return render();
      case "kit-whole": delete f.parts[el.dataset.id]; return render();
      case "kit-some": f.parts[el.dataset.id] = f.parts[el.dataset.id] || new Set(); return render();
      case "return-part":
      case "claim-part": {
        const set = f.parts[el.dataset.id] || (f.parts[el.dataset.id] = new Set());
        if (set.has(el.dataset.part)) set.delete(el.dataset.part);
        else set.add(el.dataset.part);
        return render();
      }
      case "nudge-swap": {
        const { item, target } = nudgeFor(f);
        beacon("nudge_swap", { family: item.family, issue: f.reason });
        startFlow("swap", { itemId: item.id, issue: f.reason, skipFit: true, fromReturn: true });
        S.flow.size = target.key;
        return step("confirm");
      }
      case "nudge-return": beacon("nudge_return", { family: (nudgeFor(f) || {}).item?.family, issue: f.reason }); return step("confirm");
      case "nudge-fit": {
        const { item } = nudgeFor(f);
        beacon("nudge_fit", { family: item.family, issue: f.reason });
        return startFlow("swap", { itemId: item.id, issue: f.reason === "too_small" ? "too_small" : "too_big", fromReturn: true });
      }
      case "swap-instead": return startFlow("swap", { itemId: el.dataset.id, issue: S.flow && (S.flow.reason === "too_small" || S.flow.reason === "too_big") ? S.flow.reason : undefined });
      case "submit-return": return submitReturn(el);
      case "claim-type": {
        f.type = el.dataset.type;
        const steps = activeSteps(f);
        if (f.type === "not_received" && !f.packageId && deliveredPackages().length === 1) f.packageId = deliveredPackages()[0].id;
        return step(steps[steps.indexOf("type") + 1]);
      }
      case "claim-item": {
        if (event.target.closest("[data-stop]")) return;
        const id = el.dataset.id;
        if (f.items.has(id)) f.items.delete(id);
        else f.items.add(id);
        return render();
      }
      case "claim-pkg": f.packageId = el.dataset.id; return render();
      case "photo-remove": f.photos.splice(Number(el.dataset.index), 1); return render();
      case "submit-claim": return submitClaim(el);
      case "episode-item": f.itemId = el.dataset.id; return render();
      case "submit-episode": return submitEpisode(el);
      // A link: the browser opens the episode page; this only counts the tap.
      case "episode-open": return beacon("flow", { flow: `episode_${el.dataset.what === "fix" ? "fix" : "watch"}` });
      case "not-here": return startFlow("claim", { type: "not_received", packageId: el.dataset.id });
      case "cancel-reason": f.reason = f.reason === el.dataset.reason ? "" : el.dataset.reason; return render();
      case "submit-cancel": return submitCancel(el);
      case "onway-return": return startFlow("return");
      case "onway-track": return startFlow("track");
      case "onway-claim": return startFlow("claim");
      case "submit-address": return submitAddress(el);
      case "add-tracking": return startFlow("tracking", { returnId: el.dataset.return });
      case "rate": {
        const score = el.dataset.score;
        S.feedback = { key: feedbackKey(), score, sent: score === "easy" };
        sendFeedback({ score });
        watch("quiz", "click", `rate.${score}`);
        return swapFeedback(el);
      }
      case "rate-skip":
        if (S.feedback) S.feedback.sent = true;
        return swapFeedback(el);
      case "copy": {
        const text = el.dataset.copy;
        (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject()).then(() => {
          el.querySelector("span").textContent = "Copied";
          setTimeout(() => { if (el.isConnected) el.querySelector("span").textContent = "Copy"; }, 1800);
        }).catch(() => {});
        return;
      }
      default:
    }
  });

  root.addEventListener("keydown", (event) => {
    const el = event.target;
    if ((event.key === "Enter" || event.key === " ") && el.matches && el.matches('[role="checkbox"][data-act], [role="radio"][data-act]')) {
      event.preventDefault();
      el.click();
    }
  });

  root.addEventListener("submit", (event) => {
    const form = event.target.closest("form[data-form]");
    if (!form) return;
    event.preventDefault();
    const btn = form.querySelector("button[type=submit]");
    if (form.dataset.form === "lookup") {
      return lookup(btn, form.order.value.trim(), form.identity.value.trim());
    }
    if (form.dataset.form === "feedback") {
      const comment = form.comment.value.trim();
      if (comment && S.feedback) sendFeedback({ score: S.feedback.score, comment });
      if (S.feedback) S.feedback.sent = true;
      return swapFeedback(form);
    }
    if (form.dataset.form === "tracking") {
      const number = form.number.value.trim();
      if (!number) return;
      busy(btn, async () => {
        S.result = await api("return_tracking", { returnId: form.dataset.return, number });
        go("done");
      });
    }
  });

  root.addEventListener("input", (event) => {
    const el = event.target;
    if (el.matches && el.matches("[data-sizer-range]") && S.flow) { updateSizer(true); return; }
    if (el.dataset.finderInput && S.flow) { S.flow[el.dataset.finderInput] = el.value.replace(/[^0-9.]/g, ""); updateFinder(); return; }
    if (el.dataset.bind && S.flow) S.flow[el.dataset.bind] = el.value;
    if (el.dataset.bindAddr && S.flow) S.flow.addr[el.dataset.bindAddr] = el.value;
    if (el.name === "order" && el.form && el.form.dataset.form === "lookup") S.prefill.order = el.value;
    if (el.name === "identity" && el.form && el.form.dataset.form === "lookup" && S.via === "email") S.prefill.identity = el.value;
  });

  root.addEventListener("change", (event) => {
    if (event.target.matches("[data-photo]")) addPhotos(event.target);
  });

  // ------------------------------------------------------------------ demo
  const DEMO_IMG = {
    harness: "https://cdn.shopify.com/s/files/1/2715/4364/files/2_d05f536a-614b-49a9-969f-133705ca9281.png?v=1782413026&width=400",
    harnessOnly: "https://cdn.shopify.com/s/files/1/2715/4364/files/8_09bbc960-d755-4325-bf5b-861b8c215b4f.png?v=1776179787&width=400",
    collar: "https://cdn.shopify.com/s/files/1/2715/4364/products/product-image-1308663900.jpg?v=1771457175&width=400",
    patch: "https://cdn.shopify.com/s/files/1/2715/4364/products/CUSTOMPATCH_1.png?v=1771457174&width=400",
    seat: "https://cdn.shopify.com/s/files/1/2715/4364/files/1_e9bf22e4-6089-4a40-9211-ad520765df00.png?v=1771457232&width=400",
    lightweight: "https://cdn.shopify.com/s/files/1/2715/4364/files/6_3.png?v=1787776323&width=400"
  };
  const harnessSizes = (current) => [["XS", "Extra-Small", "15–25 lb"], ["S", "Small", "25–48 lb"], ["M", "Medium", "48–78 lb"], ["L", "Large", "78–120 lb"], ["XL", "Extra-Large", "120–170+ lb"]]
    .map(([key, name, range]) => ({ key, name, range, current: key === current, available: true, priceDelta: 0, variantId: `demo-${key}` }));

  function demoOrder(number) {
    const now = Date.now();
    const iso = (days) => new Date(now - days * 86400000).toISOString();
    const returnAddress = { name: "Attn: Team K9", line1: "14143 Denver West Pkwy, Suite 100", line2: "Golden, CO 80401" };
    if (number === "268900" || number === "268600") {
      return {
        kind: "order", token: "demo",
        order: { name: `#${number}`, placedAt: iso(9), firstName: "Jamie", cancelled: false, refunded: false, stage: "shipped", protectedShipping: false, exchangeOrder: false, total: 89.99, shipTo: { city: "Austin", provinceCode: "TX" } },
        items: [{
          id: "h1", title: "Tactical Harness", detail: "K9 Black · Medium (48–78 lb)", variantLabel: "K9 Black / Medium (48-78 LB) / Harness", color: "K9 Black", kit: "",
          size: { name: "Medium", short: "M", range: "48–78 lb" }, image: DEMO_IMG.harnessOnly, qty: 1, unitPaid: 89.99, family: "harness4", shipped: true, deliveredAt: iso(4), daysLeft: 56,
          swap: { ok: true, mode: "exchange" }, sizes: harnessSizes("M"), return: { ok: true, maxQty: 1 }, claim: { ok: true }
        }],
        packages: [{ id: "p1", status: "delivered", label: "Delivered", carrier: "USPS", number: "9400111202555842760061", url: "https://tools.usps.com/go/TrackConfirmAction?tLabels=9400111202555842760061", shippedAt: iso(7), deliveredAt: iso(4), items: [{ id: "h1", qty: 1 }] }],
        returns: [], cancel: { ok: false, why: "shipped" }, address: { ok: false, why: "shipped" }, verifiedVia: "email", live: true, returnAddress
      };
    }
    if (number === "271650") {
      const page = "https://teamk9.com/pages/chief-champ-guest-star?dog=7dac3f3952";
      const episode = (id, title, sku) => ({
        id, title, detail: "Starring Siggi", variantLabel: title, color: "", kit: "", size: null, sku, image: "", qty: 1, unitPaid: 19, family: "episode", finalSale: true, shipped: true,
        episode: { dogId: "7dac3f3952", dogName: "Siggi", title, ready: true, refunded: false, watchUrl: page, fixUrl: `${page}#not-right` },
        swap: { ok: false, why: "digital" }, return: { ok: false, why: "digital" }, claim: { ok: false, why: "digital" }
      });
      return {
        kind: "order", token: "demo",
        order: { name: "#271650", placedAt: iso(0.2), firstName: "Jamie", cancelled: false, refunded: false, episodeOnly: true, stage: "digital", protectedShipping: false, exchangeOrder: false, total: 38, shipTo: { city: "Austin", provinceCode: "TX" } },
        items: [episode("e1", "Halloween special", "TK9-CC-HW-19"), episode("e2", "Guest episode", "TK9-CC-BETA-19")],
        packages: [], returns: [], cancel: { ok: false, why: "digital" }, address: { ok: false, why: "digital" }, verifiedVia: "email", live: true, returnAddress
      };
    }
    if (number === "269510") {
      return {
        kind: "order", token: "demo",
        order: { name: "#269510", placedAt: iso(0.01), firstName: "Jamie", cancelled: false, refunded: false, stage: "before_export", minutesLeft: 180, protectedShipping: false, exchangeOrder: false, total: 89.99, shipTo: { firstName: "Jamie", lastName: "Rivera", address1: "2150 Elm St", address2: "", city: "Austin", provinceCode: "TX", zip: "78701", countryCode: "US" } },
        items: [{
          id: "n1", title: "Tactical Harness", detail: "Olive Drab Green · Medium (48–78 lb)", variantLabel: "Olive Drab Green / Medium (48-78 LB) / Harness", color: "Olive Drab Green", kit: "",
          size: { name: "Medium", short: "M", range: "48–78 lb" }, image: DEMO_IMG.harnessOnly, qty: 1, unitPaid: 89.99, family: "harness4", shipped: false, daysLeft: 60,
          swap: { ok: true, mode: "edit", wholeKit: false }, sizes: harnessSizes("M"), return: { ok: false, why: "not_shipped" }, claim: { ok: true }
        }],
        packages: [{ id: "unfulfilled", status: "preparing", label: "Order received", items: [{ id: "n1", qty: 1 }] }],
        returns: [], cancel: { ok: true, mode: "auto" }, address: { ok: true, mode: "auto" }, verifiedVia: "email", live: true, returnAddress
      };
    }
    if (number === "268512") {
      return {
        kind: "order", token: "demo",
        order: { name: "#268512", placedAt: iso(10), firstName: "Jamie", cancelled: false, refunded: false, stage: "shipped", protectedShipping: false, exchangeOrder: false, total: 59.99, shipTo: { city: "Austin", provinceCode: "TX" } },
        items: [{
          id: "w1", title: "Lightweight Harness", detail: "Desert Brown · Medium (40–55 lb)", variantLabel: "Desert Brown / Medium (40-55 LB) / Harness", color: "Desert Brown", kit: "",
          size: { name: "Medium", short: "M", range: "40–55 lb" }, image: DEMO_IMG.lightweight, qty: 1, unitPaid: 59.99, family: "harness1", shipped: true, deliveredAt: iso(5), daysLeft: 55,
          swap: { ok: true, mode: "exchange" },
          sizes: [["S", "Small", "25–40 lb"], ["M", "Medium", "40–55 lb"], ["L", "Large", "55–80 lb"], ["XL", "Extra-Large", "80–100 lb"]].map(([key, name, range]) => ({ key, name, range, current: key === "M", available: true, priceDelta: 0 })),
          return: { ok: true, maxQty: 1 }, claim: { ok: true }
        }],
        packages: [{ id: "p1", status: "delivered", label: "Delivered", carrier: "USPS", number: "9400111202555842760001", url: "https://tools.usps.com/go/TrackConfirmAction?tLabels=9400111202555842760001", shippedAt: iso(8), deliveredAt: iso(5), items: [{ id: "w1", qty: 1 }] }],
        returns: [], cancel: { ok: false, why: "shipped" }, address: { ok: false, why: "shipped" }, verifiedVia: "email", live: true, returnAddress
      };
    }
    if (number === "269502") {
      return {
        kind: "order", token: "demo",
        order: { name: "#269502", placedAt: iso(0.05), firstName: "Jamie", cancelled: false, refunded: false, stage: "before_export", minutesLeft: 170, protectedShipping: false, exchangeOrder: false, total: 169.99, shipTo: { firstName: "Jamie", lastName: "Rivera", address1: "2150 Elm St", address2: "", city: "Austin", provinceCode: "TX", zip: "78701", countryCode: "US" } },
        items: [{
          id: "s1", title: "Hard Bottom Seat Cover Bundle", detail: "Black · Large (Most vehicles)", variantLabel: "Black / Large (Fits Most Vehicles) / Backseat Cover + FREE Safety Belt",
          bundle: { kind: "bundle", label: "Backseat Cover + FREE Safety Belt", components: [{ key: "cover", label: "Backseat Cover", sizable: true }, { key: "belt", label: "Safety Belt" }] }, color: "Black", kit: "Backseat Cover + FREE Safety Belt",
          size: { name: "Large", short: "L", range: "Most vehicles" }, image: DEMO_IMG.seat, qty: 1, unitPaid: 169.99, family: "seatcover", shipped: false, daysLeft: 60,
          swap: { ok: true, mode: "edit", wholeKit: true }, sizes: [{ key: "L", name: "Large", range: "Most vehicles", current: true, available: true, priceDelta: 0 }, { key: "XL", name: "Extra-Large", range: "Bigger trucks", current: false, available: true, priceDelta: 30 }],
          return: { ok: false, why: "not_shipped" }, claim: { ok: true }
        }],
        packages: [{ id: "unfulfilled", status: "preparing", label: "Order received", items: [{ id: "s1", qty: 1 }] }],
        returns: [], cancel: { ok: true, mode: "auto" }, address: { ok: true, mode: "auto" }, verifiedVia: "email", live: true, returnAddress
      };
    }
    return {
      kind: "order", token: "demo",
      order: { name: "#268431", placedAt: iso(14), firstName: "Jamie", cancelled: false, refunded: false, stage: "shipped", protectedShipping: true, exchangeOrder: false, total: 209.97, shipTo: { city: "Austin", provinceCode: "TX" } },
      items: [
        {
          id: "d1", title: "Tactical Harness Kit", detail: "K9 Black · Medium (48–78 lb)", variantLabel: "K9 Black / Medium (48-78 LB) / Harness + Bungee Leash + Tactical Collar", color: "K9 Black", kit: "Harness + Bungee Leash + Tactical Collar",
          bundle: { kind: "kit", label: "Harness + Bungee Leash + Tactical Collar", components: [{ key: "harness", label: "Harness", sizable: true }, { key: "leash", label: "Bungee Leash" }, { key: "collar", label: "Tactical Collar", sizable: true }] },
          size: { name: "Medium", short: "M", range: "48–78 lb" }, image: DEMO_IMG.harness, componentImage: DEMO_IMG.harnessOnly, qty: 1, unitPaid: 139.99, family: "harness4", shipped: true, deliveredAt: iso(8), daysLeft: 52,
          swap: { ok: true, mode: "exchange", components: ["harness", "collar"] }, sizes: harnessSizes("M"),
          collarSizes: [{ key: "M", name: "Medium", range: "13–17 in", available: true }, { key: "L", name: "Large", range: "17–20 in", available: true }, { key: "XL", name: "Extra-Large", range: "20–24 in", available: true }],
          return: { ok: true, maxQty: 1 }, claim: { ok: true }
        },
        {
          id: "d2", title: "Tactical Collar", detail: "K9 Black · Medium (13–17 in)", variantLabel: "K9 Black / Medium (13-17 in)", color: "K9 Black", kit: "",
          size: { name: "Medium", short: "M", range: "13–17 in" }, image: DEMO_IMG.collar, qty: 2, unitPaid: 29.99, family: "collar", shipped: true, deliveredAt: iso(8), daysLeft: 52,
          swap: { ok: true, mode: "exchange" }, sizes: [{ key: "M", name: "Medium", range: "13–17 in", current: true, available: true, priceDelta: 0 }, { key: "L", name: "Large", range: "17–20 in", current: false, available: true, priceDelta: 0 }, { key: "XL", name: "Extra-Large", range: "20–24 in", current: false, available: false, priceDelta: 0 }],
          return: { ok: true, maxQty: 2 }, claim: { ok: true }
        },
        {
          id: "d3", title: "Custom Hook & Loop Patch", variantLabel: "Medium (4.3 in x 1.2 in)", image: DEMO_IMG.patch, qty: 1, unitPaid: 19.99, family: "custom", shipped: true, daysLeft: 55,
          finalSale: true, swap: { ok: false, why: "final_sale" }, return: { ok: false, why: "final_sale" }, claim: { ok: true }
        }
      ],
      packages: [
        { id: "p1", status: "delivered", label: "Delivered", carrier: "USPS", number: "9400111202555842761234", url: "https://tools.usps.com/go/TrackConfirmAction?tLabels=9400111202555842761234", shippedAt: iso(12), deliveredAt: iso(8), items: [{ id: "d1", qty: 1 }, { id: "d2", qty: 2 }] },
        { id: "p2", status: "transit", label: "On the way", carrier: "USPS", number: "9400111202555842769876", url: "https://tools.usps.com/go/TrackConfirmAction?tLabels=9400111202555842769876", shippedAt: iso(3), eta: iso(-2), lastEvent: { where: "Denver, CO" }, items: [{ id: "d3", qty: 1 }] }
      ],
      returns: [], cancel: { ok: false, why: "shipped" }, address: { ok: false, why: "shipped" }, verifiedVia: "email", live: true, returnAddress
    };
  }

  function demoApi(action, payload) {
    return new Promise((resolve, reject) => setTimeout(() => {
      if (action === "lookup") {
        const number = num(payload.orderNumber);
        if (!["268431", "268512", "269502", "269510", "268600", "268900", "271650"].includes(number)) return reject(Object.assign(new Error("Demo orders: #268431, #268512 and #269502."), { status: 404 }));
        const data = demoOrder(number);
        if (params.get("live") === "0") data.live = false;
        data.giveBack = true;
        if (params.get("team") === "1") data.teamHelping = true;
        return resolve(data);
      }
      if (action === "order") return resolve(S.data);
      const item = payload.lineItemId ? itemById(payload.lineItemId) : null;
      if (S.data.teamHelping && ["exchange", "return"].includes(action)) {
        return resolve({ kind: action === "return" ? "return_requested" : "request", teamHelping: true });
      }
      if (!S.data.live && ["exchange", "return", "cancel", "address"].includes(action)) {
        if (action === "return") return resolve({ kind: "return_requested", rma: `RMA - ${num(S.data.order.name)}`, address: S.data.returnAddress });
        return resolve({ kind: action === "cancel" ? "cancel_requested" : action === "address" ? "address_requested" : "request" });
      }
      switch (action) {
        case "exchange": {
          const target = payload.size ? item.sizes.find((s) => s.key === payload.size) : null;
          if (item.swap.mode === "edit") return resolve(target.priceDelta ? { kind: "request", size: target.name } : { kind: "edited", size: target.name });
          const kit = isKitSwap(item);
          const swapped = kit ? [target && "Harness", payload.collarSize && "Tactical Collar"].filter(Boolean) : [item.title];
          const kept = kit ? item.bundle.components.filter((c) => !(c.key === "harness" && target) && !(c.key === "collar" && payload.collarSize)).map((c) => c.label) : [];
          const pd = target ? target.priceDelta : 0;
          return resolve({ kind: pd > 0 ? "upgrade" : "exchange", item: item.title, size: target ? target.name : `${payload.collarSize} collar`, swapped, kept, priceDelta: pd, exchangeOrder: "#269614", giveBack: pd <= 0 && pd >= 0 });
        }
        case "return": {
          const estimate = payload.items.reduce((sum, line) => sum + itemById(line.id).unitPaid * line.qty, 0);
          S.data.returns = [{ id: "r1", name: "#268431-R1", kind: "return", items: payload.items.map((line) => ({ id: line.id, qty: line.qty })), tracking: null }];
          return resolve({ kind: "return", estimate, rma: "RMA - 268431", address: S.data.returnAddress, returnId: "r1" });
        }
        case "return_tracking":
          S.data.returns.forEach((ret) => { if (ret.id === payload.returnId) ret.tracking = { number: payload.number }; });
          return resolve({ kind: "tracking_added", number: payload.number });
        case "claim":
          if (payload.type === "missing" && payload.items.every((id) => itemById(id) && !itemById(id).shipped)) return resolve({ kind: "ships_separately", items: payload.items.map((id) => itemById(id).title) });
          return resolve({ kind: "claim", ticket: 111204 });
        case "episode_help":
          return resolve({ kind: "episode_help", ticket: 111205 });
        case "cancel":
          return resolve({ kind: "cancelled", total: S.data.order.total });
        case "address":
          return resolve({ kind: "address_updated", address: [payload.address.address1, `${payload.address.city}, ${payload.address.provinceCode} ${payload.address.zip}`].filter(Boolean).join(", ") });
        default:
          return resolve({ kind: "request" });
      }
    }, action === "lookup" ? 650 : 900));
  }

  // ------------------------------------------------------------------ boot
  render();
  beacon("visit");
  if (cfg.demo && params.get("order")) lookup(null, params.get("order"), "demo@teamk9.com");
})();
